/* Oduree Chat-widget (spike v1).
   Custom element; praat met de chat-backend (Cloudflare Worker, SSE).
   Geschiedenis leeft in sessionStorage en gaat per request mee. */

(function () {
  'use strict';

  /* Na hoeveel stilte een volgende vraag als nieuw gesprek telt. Gelijk aan de
     grens die het klantenservice-dashboard gebruikt bij het groeperen, zodat
     widget en rapportage niet uit elkaar lopen. */
  var NIEUW_GESPREK_NA_MS = 30 * 60 * 1000;

  /* Prijzen voor Oody: per productsoort een vaste, representatieve variant.
     De prijs komt van Intelligems (testprijs van deze bezoeker) of anders uit
     Shopify via data-prijzen op <oduree-chat> (snippets/oduree-chat.liquid).
     Zo volgt Oody een prijswijziging in Shopify zonder codewijziging. Ontbreekt
     een prijs, dan gaat die soort niet mee en rekent de worker met zijn eigen
     standaard. */
  var PRIJS_VARIANTEN = {
    hanger: '51190980018522',
    togo: '53557368848730',
    togo_le: '54608657842522',
    fullsize: '51190257287514',
    huisparfum: '51972541055322',
    geurstokjes: '52042690658650',
    giftbox: '53427820101978',
  };

  /* De Oduree AI-parfumeur: levende SVG in merkleuren. De ster van Oduree is
     zijn antenne, ODUREE staat op zijn borst, en in zijn hand een flacon.
     Beweging (zweven, knipperen, glinsteren, zwaaien) zit in de CSS. */
  /* De Oduree AI-parfumeur "Oody", 1-op-1 uit de design-handoff
     (600x640-geometrie, shell-gradients, gloedfilters), aangesloten op het
     bestaande state-systeem. Merkcorrecties t.o.v. de handoff: het echte
     vette ODUREE-woordmerk op de borst en amberkleurige ogen (de gekozen
     variant) in plaats van cyaan. Gedeelde onderdelen staan in defs; ogen,
     mond, ster en zwaai-arm staan per instantie los zodat CSS-states ze
     kunnen aansturen (use-clones zijn niet per instantie te stylen). */
  var OB_DEFS =
    '<defs>' +
    '<linearGradient id="obShell" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#FFFFFF"/><stop offset="0.45" stop-color="#F3F6FA"/><stop offset="1" stop-color="#D4DDEC"/></linearGradient>' +
    '<linearGradient id="obDark" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#3B404B"/><stop offset="1" stop-color="#1C1F26"/></linearGradient>' +
    '<linearGradient id="obScreen" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#313749"/><stop offset="0.5" stop-color="#141722"/><stop offset="1" stop-color="#0A0C13"/></linearGradient>' +
    '<linearGradient id="obAmber" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#EDD29B"/><stop offset="1" stop-color="#C08E35"/></linearGradient>' +
    '<linearGradient id="obCap" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#8A6420"/><stop offset="1" stop-color="#5C3F10"/></linearGradient>' +
    '<linearGradient id="obRose" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#F4CBD3"/><stop offset="1" stop-color="#DE93A6"/></linearGradient>' +
    '<filter id="obBlur6" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="6"/></filter>' +
    '<filter id="obBlur3" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="3"/></filter>' +
    '<path id="obStar" d="M0 -20 C3 -6 6 -3 20 0 C6 3 3 6 0 20 C-3 6 -6 3 -20 0 C-6 -3 -3 -6 0 -20 Z"/>' +
    '<g id="obHead">' +
    '<rect x="296" y="50" width="8" height="50" rx="4" fill="#262932"/>' +
    '<rect x="110" y="196" width="40" height="80" rx="20" fill="url(#obDark)"/>' +
    '<rect x="450" y="196" width="40" height="80" rx="20" fill="url(#obDark)"/>' +
    '<rect x="146" y="92" width="308" height="260" rx="118" fill="url(#obShell)"/>' +
    '<ellipse cx="240" cy="140" rx="84" ry="32" fill="#FFFFFF" opacity="0.5" filter="url(#obBlur6)" transform="rotate(-16 240 140)"/>' +
    '<ellipse cx="300" cy="336" rx="96" ry="16" fill="#C4CFE0" opacity="0.35" filter="url(#obBlur6)"/>' +
    '<rect x="182" y="144" width="236" height="174" rx="46" fill="url(#obScreen)"/>' +
    '<ellipse cx="300" cy="161" rx="102" ry="18" fill="#FFFFFF" opacity="0.1"/>' +
    '<circle cx="216" cy="172" r="10" fill="#FFFFFF" opacity="0.16" filter="url(#obBlur3)"/>' +
    '</g>' +
    '<g id="obTorso">' +
    '<path d="M300 372 C246 372 210 402 210 456 C210 516 252 550 300 550 C348 550 390 516 390 456 C390 402 354 372 300 372 Z" fill="url(#obShell)"/>' +
    '<ellipse cx="300" cy="516" rx="58" ry="14" fill="#C4CFE0" opacity="0.4" filter="url(#obBlur6)"/>' +
    '<path d="M262 388 Q300 402 338 388" stroke="#D3DCEA" stroke-width="3" fill="none"/>' +
    '<text x="302" y="478" text-anchor="middle" fill="#3E4553" style="font-family:inherit;font-weight:800;font-size:27px;letter-spacing:5px">ODUREE</text>' +
    '</g>' +
    '<g id="obBottle">' +
    '<rect x="-15" y="-54" width="30" height="26" rx="7" fill="url(#obCap)"/>' +
    '<rect x="-9" y="-30" width="18" height="12" fill="#A97F33"/>' +
    '<rect x="-32" y="-18" width="64" height="84" rx="14" fill="url(#obAmber)" stroke="#A87C2C" stroke-opacity="0.35"/>' +
    '<rect x="-24" y="-10" width="10" height="60" rx="5" fill="#FFFFFF" opacity="0.35"/>' +
    '<rect x="-18" y="6" width="36" height="32" rx="6" fill="#F8F4EA" stroke="#DCCDA4"/>' +
    '<g transform="translate(0,22) scale(0.42)"><use href="#obStar" fill="var(--ster,#C79B48)"/></g>' +
    '</g>' +
    '<g id="obFlask">' +
    '<rect x="-19" y="-52" width="38" height="9" rx="4.5" fill="#9FB0C4"/>' +
    '<path d="M-14 -44 L-14 -6 L-42 42 Q-47 54 -33 54 L33 54 Q47 54 42 42 L14 -6 L14 -44 Z" fill="#DCE6F0" fill-opacity="0.55" stroke="#9FB0C4" stroke-width="2.5" stroke-linejoin="round"/>' +
    '<path d="M-24 12 L-38 40 Q-42 50 -31 50 L31 50 Q42 50 38 40 L24 12 Z" fill="url(#obRose)" opacity="0.95"/>' +
    '<circle class="ob-bubbel" cx="-8" cy="40" r="4" fill="#FFFFFF" opacity="0.8"/>' +
    '<circle class="ob-bubbel ob-bubbel2" cx="7" cy="44" r="3" fill="#FFFFFF" opacity="0.8"/>' +
    '<circle class="ob-bubbel ob-bubbel3" cx="0" cy="36" r="2.5" fill="#FFFFFF" opacity="0.8"/>' +
    '</g>' +
    '<g id="obArmDown">' +
    '<path d="M216 436 Q204 464 199 494" stroke="#262932" stroke-width="9" fill="none" stroke-linecap="round"/>' +
    '<rect x="180" y="500" width="34" height="56" rx="17" fill="url(#obShell)" transform="rotate(-9 197 528)"/>' +
    '<rect x="186" y="562" width="26" height="34" rx="13" fill="url(#obShell)" transform="rotate(-5 199 579)"/>' +
    '<rect x="190" y="600" width="9" height="16" rx="4.5" fill="#262932"/>' +
    '<rect x="202" y="602" width="9" height="13" rx="4.5" fill="#262932"/>' +
    '</g>' +
    '</defs>';

  /* Ster, ogen, mond en wangen per instantie (stuurbaar via states) */
  var OB_STER =
    '<g transform="translate(300,32)">' +
    '<circle r="15" fill="var(--ster,#C79B48)" opacity="0.4" filter="url(#obBlur6)"/>' +
    '<g class="ob-ster"><use href="#obStar" fill="var(--ster,#C79B48)"/></g>' +
    '</g>';
  var OB_GEZICHT =
    '<g class="ob-ogen">' +
    '<g class="ob-oog">' +
    '<rect x="255" y="190" width="26" height="62" rx="13" fill="var(--oog,#FFD98A)" opacity="0.9" filter="url(#obBlur6)"/>' +
    '<rect x="255" y="190" width="26" height="62" rx="13" fill="var(--oog,#FFD98A)"/>' +
    '</g>' +
    '<g class="ob-oog">' +
    '<rect x="319" y="190" width="26" height="62" rx="13" fill="var(--oog,#FFD98A)" opacity="0.9" filter="url(#obBlur6)"/>' +
    '<rect x="319" y="190" width="26" height="62" rx="13" fill="var(--oog,#FFD98A)"/>' +
    '</g>' +
    '</g>' +
    '<g class="ob-glimlach" stroke="var(--oog,#FFD98A)" fill="none" stroke-linecap="round">' +
    '<path d="M276 270 Q300 290 324 270" stroke-width="9" filter="url(#obBlur3)" opacity="0.9"/>' +
    '<path d="M276 270 Q300 290 324 270" stroke-width="8"/>' +
    '</g>' +
    '<ellipse class="ob-mond" cx="300" cy="276" rx="17" ry="13" fill="var(--oog,#FFD98A)"/>' +
    '<g class="ob-ogen-dicht" stroke="var(--oog,#FFD98A)" fill="none" stroke-linecap="round">' +
    '<path d="M248 220 Q268 200 288 220" stroke-width="9" filter="url(#obBlur3)" opacity="0.9"/>' +
    '<path d="M312 220 Q332 200 352 220" stroke-width="9" filter="url(#obBlur3)" opacity="0.9"/>' +
    '<path d="M248 220 Q268 200 288 220" stroke-width="8"/>' +
    '<path d="M312 220 Q332 200 352 220" stroke-width="8"/>' +
    '</g>' +
    '<path class="ob-mond-strak" d="M286 271 L314 271" stroke="var(--oog,#FFD98A)" stroke-width="8" stroke-linecap="round" fill="none"/>' +
    '<g class="ob-glimlach-breed" stroke="var(--oog,#FFD98A)" fill="none" stroke-linecap="round">' +
    '<path d="M270 266 Q300 294 330 266" stroke-width="9" filter="url(#obBlur3)" opacity="0.9"/>' +
    '<path d="M270 266 Q300 294 330 266" stroke-width="8"/>' +
    '</g>' +
    '<ellipse cx="224" cy="268" rx="14" ry="8" fill="var(--wang,transparent)"/>' +
    '<ellipse cx="376" cy="268" rx="14" ry="8" fill="var(--wang,transparent)"/>';

  var MASCOTTE =
    '<svg viewBox="0 0 600 660" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="%MASCOTTE_LABEL%">' +
    OB_DEFS +
    '<ellipse class="ob-schaduw" cx="300" cy="608" rx="112" ry="14" fill="#342C14" opacity="0.22" filter="url(#obBlur6)"/>' +
    '<g class="ob-lijf">' +
    '<use href="#obTorso"/>' +
    '<use href="#obArmDown"/>' +
    '<g class="ob-zwaai">' +
    '<path d="M382 432 Q416 398 442 366" stroke="#262932" stroke-width="9" fill="none" stroke-linecap="round"/>' +
    '<rect x="426" y="308" width="36" height="62" rx="18" fill="url(#obShell)" transform="rotate(38 444 339)"/>' +
    '<rect x="466" y="290" width="10" height="20" rx="5" fill="#262932" transform="rotate(28 471 300)"/>' +
    '<rect x="480" y="298" width="10" height="18" rx="5" fill="#262932" transform="rotate(46 485 307)"/>' +
    '<rect x="490" y="312" width="10" height="15" rx="5" fill="#262932" transform="rotate(64 495 319)"/>' +
    '</g>' +
    '<use href="#obHead"/>' + OB_STER + OB_GEZICHT +
    '<g class="ob-laag ob-chips">' +
    '<g transform="translate(96,54)"><rect width="122" height="40" rx="20" fill="#FFFFFF" stroke="#E4D9C2"/><text x="61" y="27" text-anchor="middle" font-size="21" font-weight="700" fill="#7A6A4A" style="font-family:inherit">%MASCOTTE_VANILLE%</text></g>' +
    '<g class="ob-chip2" transform="translate(388,30)"><rect width="146" height="40" rx="20" fill="#FFFFFF" stroke="#E4D9C2"/><text x="73" y="27" text-anchor="middle" font-size="21" font-weight="700" fill="#7A6A4A" style="font-family:inherit">Oud Wood</text></g>' +
    '<g class="ob-chip3" transform="translate(452,142)"><rect width="108" height="40" rx="20" fill="#FFFFFF" stroke="#E4D9C2"/><text x="54" y="27" text-anchor="middle" font-size="21" font-weight="700" fill="#7A6A4A" style="font-family:inherit">Citrus</text></g>' +
    '<g class="ob-chip4" transform="translate(58,160)"><rect width="100" height="40" rx="20" fill="#FFFFFF" stroke="#E4D9C2"/><text x="50" y="27" text-anchor="middle" font-size="21" font-weight="700" fill="#7A6A4A" style="font-family:inherit">Musk</text></g>' +
    '</g>' +
    '<g class="ob-laag ob-ruik">' +
    '<use href="#obBottle" transform="translate(138,478)"/>' +
    '<g transform="translate(138,410)" stroke="var(--ster,#C79B48)" fill="none" stroke-linecap="round" stroke-width="4">' +
    '<g transform="translate(-16,4)"><path class="ob-wolk" d="M0 0 C10 -8 -10 -20 0 -30" opacity="0"/></g>' +
    '<g transform="translate(2,-4)"><path class="ob-wolk ob-wolk2" d="M0 0 C12 -10 -8 -22 2 -34" opacity="0"/></g>' +
    '<g transform="translate(20,2)"><path class="ob-wolk ob-wolk3" d="M0 0 C8 -8 -8 -18 0 -28" opacity="0"/></g>' +
    '</g>' +
    '</g>' +
    '<g class="ob-laag ob-mix">' +
    '<path d="M382 430 Q414 420 432 446" stroke="#262932" stroke-width="9" fill="none" stroke-linecap="round"/>' +
    '<rect x="420" y="436" width="32" height="22" rx="11" fill="url(#obShell)" transform="rotate(24 436 447)"/>' +
    '<g transform="translate(444,420)">' +
    '<circle cy="-16" r="9" fill="#5C3F10"/>' +
    '<rect x="-4" y="-8" width="8" height="34" fill="#B9C6D6" opacity="0.9"/>' +
    '<path d="M-3 26 L3 26 L0 36 Z" fill="#B9C6D6"/>' +
    '</g>' +
    '<g fill="url(#obRose)">' +
    '<circle class="ob-druppel" cx="444" cy="462" r="4.5"/>' +
    '<circle class="ob-druppel ob-druppel2" cx="444" cy="462" r="4.5"/>' +
    '</g>' +
    '<use href="#obFlask" transform="translate(438,538) scale(0.95)"/>' +
    '<g transform="translate(504,478) scale(0.5)"><use href="#obStar" fill="var(--ster,#C79B48)" class="ob-ster"/></g>' +
    '</g>' +
    '<g class="ob-laag ob-presenteer">' +
    '<path d="M382 428 Q450 404 500 362" stroke="#262932" stroke-width="9" fill="none" stroke-linecap="round"/>' +
    '<rect x="492" y="334" width="40" height="24" rx="12" fill="url(#obShell)" transform="rotate(-14 512 346)"/>' +
    '<use href="#obBottle" transform="translate(520,278) scale(0.85)"/>' +
    '<g transform="translate(520,194) scale(0.55)"><use href="#obStar" fill="var(--ster,#C79B48)" class="ob-ster"/></g>' +
    '<g transform="translate(560,240) scale(0.3)"><use href="#obStar" fill="var(--ster,#C79B48)" class="ob-ster"/></g>' +
    '</g>' +
    '</g></svg>';

  /* Chat-avatar: alleen hoofd en ster, zoals de handoff-crop */
  var MASCOTTE_MINI =
    '<svg viewBox="118 2 364 376" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    OB_DEFS +
    '<use href="#obHead"/>' + OB_STER + OB_GEZICHT +
    '</svg>';

  /* Paperclip in de invoerbalk. Dunne lijn, zelfde gewicht als het
     terugpijltje ernaast, zodat hij niet gaat schreeuwen om aandacht. */
  var CLIP_ICOON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M21.44 11.05l-8.49 8.49a5.5 5.5 0 0 1-7.78-7.78l8.49-8.49a3.5 3.5 0 0 1 4.95 4.95l-8.49 8.49a1.5 1.5 0 0 1-2.12-2.12l7.78-7.78"/>' +
    '</svg>';

  class OdureeChat extends HTMLElement {
    connectedCallback() {
      this.endpoint = (this.dataset.endpoint || '').replace(/\/+$/, '');
      this.strings = this.ontcijfer(JSON.parse(this.dataset.strings || '{}'));
      this.storeKey = 'oduree-chat-v1';
      this.pageOrigineel = this.dataset.page || '';
      this.productFocus = null;
      this.busy = false;
      this.render();
      this.restore();
      window.oduChat = this; /* handvat voor testen: oduChat.toonNudge() */
      this.volgPrijstest();
      this.koppelProductknoppen();
      /* Previewlinks krijgen van Shopify een balk over de rechteronderhoek.
         Die vangt de klik op de chatknop af, dus daar schuiven knop en
         melding erboven. Op de echte winkel verandert er niets. */
      const balk = () => {
        if (document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe')) {
          this.style.setProperty('--oc-onder', '78px');
          this.style.setProperty('--oc-onder-extra', '58px');
        }
      };
      balk();
      setTimeout(balk, 1500);
      this.scheduleProactive();
      this.scheduleNudge();
      this.haloEenmaal();
      this.startKarakter();
    }

    /* ---------- Karakter-states ----------
       Eén centrale stand op het element (data-bot); alle verschijningen van
       de parfumeur (launcher, header, groet-figuur, actieve avatar) lezen
       hem via CSS. Basisstanden lopen door (idle, denkt, antwoordt);
       flitsen (welkom, begint, blij, oeps, knipoog, rondkijken) zijn kort
       en vallen daarna netjes terug op de basis. */
    startKarakter() {
      this._basis = 'idle';
      this._botTimer = null;
      this._laatsteActie = Date.now();
      this.setAttribute('data-bot', 'idle');

      const actief = () => { this._laatsteActie = Date.now(); };
      this.list.addEventListener('scroll', actief, { passive: true });

      /* Gebruiker typt: nieuwsgierig meekijken zolang er niets loopt */
      this.input.addEventListener('input', () => {
        actief();
        if (this._basis === 'idle' && !this._botTimer) {
          this.setAttribute('data-bot', this.input.value.trim() ? 'typt' : 'idle');
        }
      });
      this.input.addEventListener('blur', () => {
        if (this._basis === 'idle' && !this._botTimer) this.setAttribute('data-bot', 'idle');
      });

      /* Ogen volgen de muis (subtiel, alleen via CSS-variabelen) */
      let raf = 0;
      document.addEventListener('mousemove', (e) => {
        actief();
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          const x = Math.max(-1, Math.min(1, (e.clientX / window.innerWidth) * 2 - 1));
          const y = Math.max(-1, Math.min(1, (e.clientY / window.innerHeight) * 2 - 1));
          this.style.setProperty('--kijkx', (x * 2.2).toFixed(1) + 'px');
          this.style.setProperty('--kijky', (y * 1.5).toFixed(1) + 'px');
        });
      }, { passive: true });

      /* Klik op het karakter: knipoog */
      const knipoog = () => this.flits('knipoog', 900);
      this.querySelector('.oc-header-mark').addEventListener('click', knipoog);
      this.list.addEventListener('click', (e) => {
        if (e.target.closest && e.target.closest('.oc-mascotte')) knipoog();
      });

      /* Lang niets gedaan: rondkijken, hooguit twee keer per pagina, zodat de knop niet blijft bewegen */
      let blikken = 0;
      this._verveling = setInterval(() => {
        if (document.hidden || this._basis !== 'idle' || this._botTimer) return;
        /* De dichte knop staat stil: rondkijken alleen in de geopende chat. */
        if (!this.panel.hasAttribute('data-open')) return;
        if (Date.now() - this._laatsteActie > 40000) {
          if (++blikken > 2) { clearInterval(this._verveling); return; }
          this.flits('rondkijken', 3200);
          this._laatsteActie = Date.now() - 26000; /* volgende blik over ± 15 s */
        }
      }, 6000);
    }

    zetBasis(stand) {
      this._basis = stand;
      if (!this._botTimer) this.setAttribute('data-bot', stand);
    }

    flits(stand, duur) {
      if (this._botTimer) clearTimeout(this._botTimer);
      this.setAttribute('data-bot', stand);
      this._botTimer = setTimeout(() => {
        this._botTimer = null;
        this.setAttribute('data-bot', this._basis);
      }, duur);
    }

    /* Proactieve opening (het Louis Vuitton-moment): na X seconden rondkijken
       zonder chatcontact opent het paneel één keer per sessie met een geurvraag. */
    scheduleProactive() {
      if (this.dataset.proactive !== 'true' || !this.strings.proactive) return;
      let shown = null;
      try { shown = sessionStorage.getItem('oc-proactive'); } catch (e) { /* prima */ }
      if (shown || this.history.length) return;
      const delay = Math.max(5, parseInt(this.dataset.proactiveDelay || '20', 10)) * 1000;
      this.proTimer = setTimeout(() => {
        if (this.panel.hasAttribute('data-open') || this.history.length || this.busy) return;
        try { sessionStorage.setItem('oc-proactive', '1'); } catch (e) { /* prima */ }
        this.panel.setAttribute('data-open', '');
        this.schermVast();
        this.flits('welkom', 1900);
        const chips = Array.isArray(this.strings.proactiveChips) ? this.strings.proactiveChips : [];
        this.addMessage('assistant', this.strings.proactive + chips.map((c) => '\n[[VRAAG|' + c + ']]').join(''), false);
      }, delay);
    }

    /* Zoekend gedrag: veel scrollen zonder dat er iets gebeurt. Dan tikt de
       chat één keer zacht op de schouder; het paneel gaat niet vanzelf open,
       want dat neemt een beslissing die de klant zelf hoort te nemen. */
    /* ---------- Oody op de productfoto ----------
       De knop in de galerij opent een gesprek over dat ene product en die ene
       geur: Oody opent met wat de geur is, en blijft daarna bij dit product. */
    koppelProductknoppen() {
      const vullen = () => {
        document.querySelectorAll('.oc-vraagknop .oc-vraagknop-mark').forEach((mark) => {
          if (!mark.innerHTML.trim()) mark.innerHTML = MASCOTTE_MINI;
        });
      };
      vullen();
      setTimeout(vullen, 1500);
      this.stemAfOpProduct();
      /* Via het document, want de galerij kan bij een variantwissel opnieuw
         opgebouwd worden; dan overleeft een directe listener het niet. */
      document.addEventListener('click', (e) => {
        const knop = e.target && e.target.closest && e.target.closest('.oc-vraagknop');
        if (!knop) return;
        e.preventDefault();
        /* Aanraakscherm: eerste tik toont de vragen, tweede tik opent de chat
           om zelf iets te vragen. Met een muis staat het menu al open van de
           hover, dus daar opent een klik meteen de chat. */
        const zonderHover = window.matchMedia && !window.matchMedia('(hover: hover)').matches;
        if (zonderHover && this._vraagmenuOpen && !this._vraagmenuOpen() && this._vraagmenuOpenen) {
          this._vraagmenuOpenen();
          return;
        }
        if (this._vraagmenuDicht) this._vraagmenuDicht();
        this.openProduct(knop);
      });
    }

    /* Staat de klant op een productpagina, dan benoemen de startvragen dat
       product ("Past Arabian Tonka bij mij?" in plaats van "deze geur") en
       weet de assistent om welke geur het gaat, ook als de klant de chat
       gewoon rechtsonder opent. */
    stemAfOpProduct() {
      const knop = document.querySelector('.oc-vraagknop');
      if (!knop) return;
      const deel = this.productDelen(knop);
      if (!deel.label) return;
      this.productPagina = deel;
      const knopFoto = document.querySelector('.oc-vraagknop');
      if (knopFoto) this.bouwVraagmenu(knopFoto, deel);
      // i18n-ok: context voor het model, geen klanttekst
      this.dataset.page = 'De klant bekijkt nu de productpagina van: ' + deel.label + '.';
      this.pageOrigineel = this.dataset.page;
      const sjablonen = Array.isArray(this.strings.starterProduct) ? this.strings.starterProduct : [];
      if (sjablonen.length) {
        this.strings.starters = sjablonen.map((t) =>
          t.replace(/%g/g, deel.geur).replace(/%p/g, deel.product));
      }
    }

    /* De drie vragen ook op de pagina zelf, onder de geurnoten. Wie ze daar
       ziet staan hoeft de chat niet eerst te openen om te weten wat hij kan
       vragen. Een geurwissel is een paginawissel, dus dit blijft kloppen. */
    productVragen(deel) {
      const sjablonen = Array.isArray(this.strings.starterProduct) ? this.strings.starterProduct : [];
      if (!sjablonen.length || !deel || !deel.label) return [];
      return sjablonen.map((t) => t.replace(/%g/g, deel.geur).replace(/%p/g, deel.product));
    }

    /* Het sterretje van de chips, als losse maker. */
    chipSter() {
      return '<svg viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">' +
        '<path d="M6 0l1.4 4.6L12 6 7.4 7.4 6 12 4.6 7.4 0 6l4.6-1.4Z"/></svg>';
    }

    /* Zwevend menu bij de knop op de foto: op een muis verschijnt het bij
       hover, op een aanraakscherm bij de eerste tik. De tweede tik opent de
       chat om zelf iets te vragen. Het menu hangt aan de body, want de
       fotolijst knipt alles wat erbuiten valt af. */
    bouwVraagmenu(knop, deel) {
      const vragen = this.productVragen(deel);
      if (!vragen.length || this._vraagmenu) return;

      const menu = document.createElement('div');
      menu.className = 'oc-vraagmenu';
      menu.hidden = true;
      const kop = document.createElement('div');
      kop.className = 'oc-vraagmenu-kop';
      const mark = document.createElement('span');
      mark.className = 'oc-vraagmenu-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.innerHTML = MASCOTTE_MINI;
      const titel = document.createElement('span');
      titel.textContent = this.strings.sub || 'AI perfumer by Oduree';
      kop.append(mark, titel);
      menu.appendChild(kop);
      vragen.forEach((vraag) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'oc-vraagmenu-item';
        b.innerHTML = this.chipSter();
        b.append(document.createTextNode(vraag));
        b.addEventListener('click', () => { dicht(); this.openProduct(knop, vraag); });
        menu.appendChild(b);
      });
      document.body.appendChild(menu);
      this._vraagmenu = menu;

      const hoverbaar = !window.matchMedia || window.matchMedia('(hover: hover)').matches;
      knop.setAttribute('aria-haspopup', 'true');
      knop.setAttribute('aria-expanded', 'false');

      /* Standaard klapt hij naar beneden uit, met het puntje naar de knop.
         Alleen als daar geen ruimte is klapt hij alsnog omhoog. */
      const plaats = () => {
        const r = knop.getBoundingClientRect();
        menu.style.right = Math.max(10, window.innerWidth - r.right) + 'px';
        menu.style.top = '';
        menu.style.bottom = '';
        menu.hidden = false;
        /* Liever omlaag: dat is de richting die bij een knop hoort. Past het
           net niet, dan mag het menu binnenin scrollen; pas als er echt geen
           ruimte is klapt hij omhoog. */
        const onder = window.innerHeight - r.bottom - 20;
        if (onder >= 140) {
          menu.dataset.richting = 'omlaag';
          menu.style.top = (r.bottom + 12) + 'px';
          menu.style.maxHeight = (onder - 4) + 'px';
        } else {
          menu.dataset.richting = 'omhoog';
          menu.style.bottom = (window.innerHeight - r.top + 12) + 'px';
          menu.style.maxHeight = Math.max(140, r.top - 20) + 'px';
        }
      };
      const open = () => {
        if (!menu.hidden) return;
        menu.hidden = false;
        plaats();
        knop.setAttribute('aria-expanded', 'true');
      };
      const dicht = () => {
        if (menu.hidden) return;
        menu.hidden = true;
        knop.setAttribute('aria-expanded', 'false');
      };
      this._vraagmenuOpen = () => !menu.hidden;
      this._vraagmenuOpenen = open;
      this._vraagmenuDicht = dicht;

      if (hoverbaar) {
        let weg = null;
        const blijf = () => { if (weg) { clearTimeout(weg); weg = null; } };
        const vertraagd = () => { blijf(); weg = setTimeout(dicht, 220); };
        knop.addEventListener('mouseenter', () => { blijf(); open(); });
        knop.addEventListener('mouseleave', vertraagd);
        menu.addEventListener('mouseenter', blijf);
        menu.addEventListener('mouseleave', vertraagd);
        knop.addEventListener('focus', open);
      }

      document.addEventListener('click', (e) => {
        if (menu.hidden) return;
        if (e.target.closest && (e.target.closest('.oc-vraagmenu') || e.target.closest('.oc-vraagknop'))) return;
        dicht();
      }, true);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') dicht(); });
      window.addEventListener('scroll', dicht, { passive: true });
      window.addEventListener('resize', dicht, { passive: true });
    }

    /* "Savage · Autoparfum Hanger": de variant uit de URL wint, want die
       verandert zodra de klant een andere geur kiest. */
    productDelen(knop) {
      let variant = knop.dataset.variant || '';
      try {
        const kaart = JSON.parse(knop.dataset.varianten || '{}');
        const id = new URLSearchParams(window.location.search).get('variant');
        if (id && kaart[id]) variant = kaart[id];
      } catch (e) { /* prima, dan de standaardvariant */ }
      const naam = (knop.dataset.product || '').trim();
      variant = variant.replace(/\s*\/\s*/g, ' · ').trim();
      const kaal = !variant || variant === 'Default Title' || naam.indexOf(variant) > -1;
      return {
        geur: kaal ? naam : variant.split(' · ')[0],
        product: naam,
        label: kaal ? naam : variant + ' · ' + naam,
        kaal: kaal, /* product zonder geurkeuze (cadeaubox, sleutelhanger, Travel Mug) */
      };
    }

    productLabel(knop) {
      return this.productDelen(knop).label;
    }

    /* Is deze kaart het artikel waar de klant op staat? "Savage · To-Go ·
       Autoparfum Spray" en "Savage · Autoparfum Spray To-Go" zijn hetzelfde
       artikel, en Full-Size is de naamloze standaardvorm. */
    /* Strook onder de balie: waar dit gesprek over gaat. Zo is het ook na
       drie antwoorden nog duidelijk welk product de klant open had staan. */
    toonContext(label) {
      let strook = this.querySelector('.oc-context');
      if (!strook) {
        strook = document.createElement('div');
        strook.className = 'oc-context';
        const kop = document.createElement('span');
        kop.className = 'oc-context-label';
        kop.textContent = this.strings.contextLabel || 'About this product';
        const naam = document.createElement('span');
        naam.className = 'oc-context-naam';
        strook.append(kop, naam);
        this.panel.insertBefore(strook, this.list);
      }
      strook.querySelector('.oc-context-naam').textContent = label;
    }

    verbergContext() {
      const strook = this.querySelector('.oc-context');
      if (strook) strook.remove();
    }

    zelfdeProduct(titel) {
      if (!this.productFocus || !titel) return false;
      const sleutel = (t) => String(t)
        .toLowerCase()
        .replace(/full[\s-]?size/g, ' ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .split(' ')
        .filter(Boolean)
        .sort()
        .join(' ');
      return sleutel(titel) === sleutel(this.productFocus);
    }

    openProduct(knop, vraag) {
      const label = this.productLabel(knop);
      if (!label) return;
      this.productFocus = label;
      this.toonContext(label);
      /* De backend leest dit als productgesprek en houdt het gesprek bij dit
         product; de tekst zelf is context, geen instructie. */
      this.dataset.page = 'PRODUCTGESPREK over ' + label + '. De klant staat op de productpagina van dit artikel.';
      if (this.proTimer) { clearTimeout(this.proTimer); this.proTimer = null; }
      try { sessionStorage.setItem('oc-proactive', '1'); } catch (e) { /* prima */ }
      this.stopNudge();
      this.removeAttribute('data-attentie');
      this.hintRust(7);
      this.nudgeZet('oc-stip', 0);
      /* Geen begroeting: het gesprek begint met dit product. */
      this._laatsteActie = Date.now();
      this.panel.setAttribute('data-open', '');
      this.schermVast();
      this.flits('welkom', 1900);
      if (vraag) {
        if (this.busy) return;
        this.input.value = vraag;
        this.submit();
        return;
      }
      /* Zonder meegegeven vraag wil de klant zelf iets vragen: we tonen de
         suggesties en zetten het invoerveld klaar, zonder alvast iets te
         versturen. */
      if (!this.history.length && !this.list.childElementCount) {
        const suggesties = this.productVragen(this.productPagina || {});
        if (suggesties.length) {
          this.paint('assistant', suggesties.map((v) => '[[VRAAG|' + v + ']]').join('\n'));
        }
      }
      if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) this.input.focus();
    }

    /* ---------- Hulp aanbieden: rustig, en alleen bij twijfel ----------
       Lucas (26 okt 2026): Oody sprong te vaak en te groot op, zeker bij nieuwe
       bezoekers die al de cookiemelding en de kraskaart kregen. Daarom:
       - Alleen op collecties en het geurenoverzicht, en pas bij twijfel: in deze sessie twee of
         meer geuren bekeken, terug op een collectie en daar 25 s rustig
         rondgekeken, zonder cookiemelding, kraskaart, lade of menu in beeld.
         (25 s, zodat hij nooit samenvalt met de kraskaart, die na 20 s komt.)
       - Alleen op een computer met muis: één regel naast de chatknop. Telefoon en
         tablet krijgen niets vanzelf; geen stip, geen sprongetje.
       - Hooguit één keer per sessie en één keer per 7 dagen. Weggeklikt: 30
         dagen stil. Chat gebruikt of iets in de winkelwagen: 7 dagen stil.
       Op productpagina's is de knop op de productfoto de uitnodiging.
       Testen: ?odu-nudge=1 toont de hint meteen, zonder voorwaarden. */
    nudgeGetal(sleutel, standaard) {
      try { return parseInt(sessionStorage.getItem(sleutel) || standaard, 10); } catch (e) { return parseInt(standaard, 10); }
    }

    nudgeZet(sleutel, waarde) {
      try { sessionStorage.setItem(sleutel, String(waarde)); } catch (e) { /* prima */ }
    }

    lokaalGetal(sleutel) {
      try { return parseInt(localStorage.getItem(sleutel) || '0', 10) || 0; } catch (e) { return 0; }
    }

    /* Stilte voor de hint, over sessies en tabbladen heen. Een langere stilte wint altijd. */
    hintRust(dagen) {
      const tot = Date.now() + dagen * 86400000;
      if (tot <= this.lokaalGetal('oc-hint-rust')) return;
      try { localStorage.setItem('oc-hint-rust', String(tot)); } catch (e) { /* prima */ }
    }

    /* Alleen op een computer met muis komt er ooit tekst; telefoon en tablet krijgen niets vanzelf. */
    hintPast() {
      return !!(window.matchMedia && window.matchMedia('(min-width: 1024px) and (hover: hover)').matches);
    }

    /* Collecties, alle collecties en het geurenoverzicht: daar kiezen mensen tussen geuren. */
    hintPagina() {
      return this.dataset.ctx === 'collection' || this.dataset.hint === 'true';
    }

    /* De ringen om de knop spelen één keer per bezoek, pas als de cookiemelding beantwoord is. */
    haloEenmaal() {
      if (this.nudgeGetal('oc-halo', '0')) return;
      let pogingen = 0;
      const probeer = () => {
        if (this.cookieKeuzeGemaakt() && !this.ietsAndersOpen()) {
          this.nudgeZet('oc-halo', 1);
          this.setAttribute('data-halo', '');
          return;
        }
        if (++pogingen < 60) setTimeout(probeer, 2000);
      };
      setTimeout(probeer, 1500);
    }

    /* Bekeken geuren in deze sessie, op geurnaam: dezelfde geur als Hanger en als Spray telt één keer,
       en producten zonder geur (cadeaubon, sleutelhanger) tellen niet mee. */
    bekekenGeuren() {
      try {
        const lijst = JSON.parse(sessionStorage.getItem('oc-geuren2') || '[]');
        return Array.isArray(lijst) ? lijst : [];
      } catch (e) { return []; }
    }

    onthoudGeur() {
      const deel = this.productPagina;
      if (!deel || deel.kaal || !deel.geur) return;
      const geur = deel.geur;
      const sleutel = String(geur).trim().toLowerCase();
      const lijst = this.bekekenGeuren();
      if (!sleutel || lijst.indexOf(sleutel) !== -1) return;
      lijst.push(sleutel);
      try { sessionStorage.setItem('oc-geuren2', JSON.stringify(lijst.slice(-12))); } catch (e) { /* prima */ }
    }

    /* Heeft de bezoeker de cookiemelding al beantwoord? Tot die tijd blijft Oody stil. */
    cookieKeuzeGemaakt() {
      const banner = document.getElementById('shopify-pc__banner');
      if (banner && banner.getBoundingClientRect().height > 0) {
        const cs = getComputedStyle(banner);
        if (cs.display !== 'none' && cs.visibility !== 'hidden') return false;
      }
      /* shouldShowBanner() zegt alleen of de regio een melding vraagt (blijft ook na de keuze true);
         of de bezoeker al koos, staat in de toestemming zelf: leeg tot er geaccepteerd of geweigerd is. */
      try {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) {
          const keuze = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
          const leeg = keuze
            ? ['marketing', 'analytics', 'preferences'].every((k) => !keuze[k])
            : (typeof cp.getTrackingConsent === 'function' && cp.getTrackingConsent() === 'no_interaction');
          if (leeg) return false;
        }
      } catch (e) { /* prima */ }
      return true;
    }

    /* Staat er al iets anders in beeld (de chat, een lade, het menu, de kraskaart,
       een Klaviyo-formulier of de cookiemelding), dan niet eroverheen. */
    ietsAndersOpen() {
      if (this.panel.hasAttribute('data-open')) return true;
      const zichtbaar = (el) => {
        if (!el || this.contains(el) || el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
        const r = el.getBoundingClientRect();
        if (r.width < 40 || r.height < 40) return false;
        const cs = getComputedStyle(el);
        return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
      };
      if (document.body.classList.contains('cart-drawer-open') || document.documentElement.classList.contains('lock')) return true;
      /* Thema-lades en -vensters (menu, zoeken, snel kopen, filters) staan open met het attribuut open. */
      if (document.querySelector('x-modal[open], x-drawer[open], header-sidebar[open], header-search[open], x-popover[open], quick-buy-modal[open], facets-drawer[open], .pswp--open')) return true;
      const kandidaten = document.querySelectorAll('[aria-modal="true"], dialog[open], .owp:not([hidden]), .oc-vraagmenu:not([hidden]), #shopify-pc__banner, .needsclick[role="dialog"], [data-testid="POPUP"], [class*="klaviyo-form"][role="dialog"]');
      for (const el of kandidaten) if (zichtbaar(el)) return true;
      return false;
    }

    scheduleNudge() {
      if (this.dataset.nudge === 'false' || !this.strings.hint) return;

      /* Iets in de winkelwagen gelegd: een week stil. Alle toevoegroutes (+ op de collectiekaart,
         het koopblok, het productformulier, een pakket uit de chat, de puntenshop) sturen na een
         geslaagde toevoeging cart:refresh; de klik vangt daarnaast de knoppen zelf. */
      const gekocht = () => { this.hintRust(7); this.stopNudge(); };
      document.addEventListener('cart:refresh', gekocht);
      document.addEventListener('click', (e) => {
        const koopt = e.target && e.target.closest &&
          e.target.closest('[name="add"], [action*="/cart/add"] [type="submit"], .shopify-payment-button, .oduree-prod-card__add, [data-bb-cta]');
        if (koopt) gekocht();
      }, true);
      /* Ligt er al iets in de winkelwagen, dan is de bezoeker geholpen. */
      if (parseInt(this.dataset.cart || '0', 10) > 0) this.hintRust(7);

      if (this.dataset.ctx === 'product') this.onthoudGeur();

      /* Terug naar deze pagina uit het geheugen van de browser (terugknop): stip bijwerken en opnieuw kijken. */
      window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        if (this.hintPagina() && this.hintPast() && !this._nudgeTijd && !this.querySelector('.oc-nudge')) this.planHint();
      });

      /* Testhaak: met ?odu-nudge=1 in de URL komt de hint zonder voorwaarden of geheugen,
         zodra er niets anders in beeld is (dus na de cookiekeuze). */
      if (/[?&]odu-nudge=1/.test(window.location.search)) {
        const test = setInterval(() => {
          if (!this.cookieKeuzeGemaakt() || this.ietsAndersOpen()) return;
          clearInterval(test);
          this.toonNudge(true);
        }, 500);
        return;
      }
      if (this.hintPagina() && this.hintPast()) this.planHint();
    }

    /* Mag de hint (nog) komen? Elke seconde opnieuw gevraagd, zodat een ander tabblad of een
       pagina uit het browsergeheugen nooit met een verouderd antwoord verder telt. */
    magHint() {
      const nu = Date.now();
      if (this.nudgeGetal('oc-hint-getoond', '0')) return false;              /* één keer per sessie */
      if (nu - this.lokaalGetal('oc-hint-tijd') < 7 * 86400000) return false; /* één keer per 7 dagen */
      if (nu < this.lokaalGetal('oc-hint-rust')) return false;                /* weggeklikt, gechat of gekocht */
      if (this.history.length) return false;                                  /* kent Oody al */
      return this.bekekenGeuren().length >= 2;                                /* twijfel tussen geuren */
    }

    /* 25 s rustig op deze pagina: alleen seconden waarin niets anders in beeld is tellen mee.
       Verschijnt er iets (cookiemelding, kraskaart, lade, menu), dan begint de telling opnieuw. */
    planHint() {
      this.stopNudgeKijker();
      if (!this.magHint()) return;
      const NODIG = 25;
      let rustig = 0;
      this._nudgeTijd = setInterval(() => {
        if (document.hidden) return;
        if (!this.magHint()) { this.stopNudgeKijker(); return; }
        if (!this.cookieKeuzeGemaakt() || this.ietsAndersOpen()) { rustig = 0; return; }
        rustig += 1;
        if (rustig < NODIG) return;
        this.stopNudgeKijker();
        this.toonNudge();
      }, 1000);
    }

    toonNudge(test) {
      this.stopNudgeKijker();
      if (this.panel.hasAttribute('data-open') || this.querySelector('.oc-nudge')) return;
      if (!test && !this.magHint()) return;
      /* Telefoon en tablet: niets vanzelf. Geen stip en geen sprongetje: de knop blijft rustig. */
      if (!this.hintPast()) return;
      if (!test) {
        this.nudgeZet('oc-hint-getoond', 1);
        try { localStorage.setItem('oc-hint-tijd', String(Date.now())); } catch (e) { /* prima */ }
      }

      const bel = document.createElement('div');
      bel.className = 'oc-nudge oc-hint';
      const tekst = document.createElement('button');
      tekst.type = 'button';
      tekst.className = 'oc-hint-tekst';
      tekst.textContent = this.strings.hint;
      tekst.addEventListener('click', () => this.toggle(true));
      const sluit = document.createElement('button');
      sluit.type = 'button';
      sluit.className = 'oc-nudge-sluit';
      sluit.setAttribute('aria-label', this.strings.nudgeClose || this.strings.close || 'Dismiss');
      sluit.textContent = '×';
      const wegklikken = () => {
        /* Zelf weggeklikt: een maand stil. */
        if (!test) this.hintRust(30);
        this.stopNudge();
      };
      sluit.addEventListener('click', wegklikken);
      bel.addEventListener('keydown', (e) => { if (e.key === 'Escape') wegklikken(); });
      bel.append(tekst, sluit);
      this.appendChild(bel);

      /* Vanzelf weg na 15 s; niet zolang de muis erop staat of de focus erin zit. */
      const blijf = () => { if (this._nudgeWeg) { clearTimeout(this._nudgeWeg); this._nudgeWeg = null; } };
      const later = () => {
        if (!this._nudgeWeg && !bel.matches(':hover') && !bel.contains(document.activeElement)) {
          this._nudgeWeg = setTimeout(() => this.stopNudge(), 6000);
        }
      };
      bel.addEventListener('pointerenter', blijf);
      bel.addEventListener('focusin', blijf);
      bel.addEventListener('pointerleave', later);
      bel.addEventListener('focusout', (e) => { if (!bel.contains(e.relatedTarget)) setTimeout(later, 0); });
      this._nudgeWeg = setTimeout(() => this.stopNudge(), 15000);
      /* Komt er intussen iets anders in beeld (kraskaart, lade, menu), dan maakt de hint plaats. */
      this._nudgeWacht = setInterval(() => { if (this.ietsAndersOpen()) this.stopNudge(); }, 1000);
    }

    stopNudgeKijker() {
      if (this._nudgeTijd) { clearInterval(this._nudgeTijd); this._nudgeTijd = null; }
    }

    stopNudge() {
      this.stopNudgeKijker();
      if (this._nudgeWacht) { clearInterval(this._nudgeWacht); this._nudgeWacht = null; }
      if (this._nudgeWeg) { clearTimeout(this._nudgeWeg); this._nudgeWeg = null; }
      const bel = this.querySelector('.oc-nudge');
      if (!bel) return;
      /* Stond de toetsenbordfocus in de hint, dan gaat hij naar de chatknop in plaats van naar het begin van de pagina. */
      if (bel.contains(document.activeElement)) {
        const knop = this.querySelector('.oc-launcher');
        if (knop) knop.focus();
      }
      bel.setAttribute('data-weg', '');
      setTimeout(() => bel.remove(), 320);
    }


    render() {
      this.innerHTML =
        '<button type="button" class="oc-launcher" aria-label="' + this.esc(this.strings.open) + '">' + MASCOTTE_MINI + '</button>' +
        '<section class="oc-panel" role="dialog" aria-modal="false" aria-label="' + this.esc(this.strings.title) + '">' +
        '<header class="oc-header"><div class="oc-header-id">' +
        '<span class="oc-header-mark" aria-hidden="true">' + MASCOTTE_MINI + '</span>' +
        '<div><div class="oc-header-title">' + this.esc(this.strings.title) + '</div>' +
        '<span class="oc-header-sub">' + this.esc(this.strings.sub) + '</span></div></div>' +
        '<button type="button" class="oc-close" aria-label="' + this.esc(this.strings.close) + '">&times;</button></header>' +
        '<div class="oc-messages" aria-live="polite"></div>' +
        '<div class="oc-bijlagen" hidden></div>' +
        '<form class="oc-form"><button type="button" class="oc-reset" aria-label="' + this.esc(this.strings.reset || 'Start over') + '">&#8634;</button>' +
        '<button type="button" class="oc-clip" aria-label="' + this.esc(this.strings.addPhoto || 'Attach a photo') + '">' + CLIP_ICOON + '</button>' +
        '<input type="file" class="oc-bestand" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,image/*" multiple hidden>' +
        '<input class="oc-input" maxlength="2000" autocomplete="off" placeholder="' + this.esc(this.strings.placeholder) + '">' +
        '<button type="submit" class="oc-send">' + this.esc(this.strings.send) + '</button></form>' +
        '</section>';

      this.panel = this.querySelector('.oc-panel');
      this.list = this.querySelector('.oc-messages');
      this.input = this.querySelector('.oc-input');
      this.send = this.querySelector('.oc-send');
      this.strook = this.querySelector('.oc-bijlagen');
      this.bestandveld = this.querySelector('.oc-bestand');
      this.bijlagen = [];
      this.querySelector('.oc-clip').addEventListener('click', () => {
        if (this.busy) return;
        this.bestandveld.click();
      });
      this.bestandveld.addEventListener('change', () => {
        const gekozen = Array.from(this.bestandveld.files || []);
        this.bestandveld.value = '';
        gekozen.forEach((f) => this.voegBijlageToe(f));
      });

      this.querySelector('.oc-launcher').addEventListener('click', () => this.toggle(true));
      this.querySelector('.oc-close').addEventListener('click', () => this.toggle(false));
      this.querySelector('.oc-reset').addEventListener('click', () => {
        if (this.busy) return;
        /* Opnieuw beginnen is ook: de klaargezette foto's van tafel. */
        (this.bijlagen || []).forEach((b) => { if (b.voorbeeld) URL.revokeObjectURL(b.voorbeeld); });
        this.bijlagen = [];
        this.tekenBijlagen();
        this.history = [];
        this.persist();
        this.list.replaceChildren();
        this.productFocus = null;
        this.verbergContext();
        if (this.pageOrigineel !== undefined) this.dataset.page = this.pageOrigineel;
        this.addMessage('assistant', this.greetingText(), false);
        this.input.focus();
      });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.toggle(false); });
      /* Legt de klant iets in de wagen vanuit de chat, dan opent de theme de
         cart-drawer. Die ligt onder het chatpaneel, dus stappen we opzij. */
      document.addEventListener('cart:open', () => {
        if (this.panel.hasAttribute('data-open')) this.toggle(false);
      });
      this.querySelector('.oc-form').addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
    }

    toggle(open) {
      if (open) {
        this._laatsteActie = Date.now(); /* net geopend: niet meteen verveeld rondkijken */
        if (this.proTimer) { clearTimeout(this.proTimer); this.proTimer = null; }
        this.stopNudge();
        this.removeAttribute('data-attentie');
        /* Chat zelf geopend: dan weet de klant Oody te vinden. */
        this.hintRust(7);
        this.nudgeZet('oc-stip', 0);
        try { sessionStorage.setItem('oc-proactive', '1'); } catch (e) { /* prima */ }
        this.panel.setAttribute('data-open', '');
        this.schermVast();
        /* Begroeting alleen als het gesprek ook visueel leeg is; anders stapelt
           elke open/dicht een extra welkomstbericht op. */
        if (!this.history.length && !this.list.childElementCount) {
          this.addMessage('assistant', this.greetingText(), false);
          this.flits('welkom', 1900);
        }
        /* Alleen op desktop meteen focussen. Op mobiel opent focus het
           toetsenbord midden in de openanimatie en dat sloopt de layout
           (iOS scrolt het veld in beeld via de pagina); net als WhatsApp
           komt het toetsenbord daar pas als de klant zelf op het veld tikt. */
        if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) this.input.focus();
      } else {
        this.panel.removeAttribute('data-open');
        this.schermLos();
      }
    }

    /* ---------- Mobiel: toetsenbord- en scrollgedrag ----------
       Op een telefoon hoort de chat zich als een app te gedragen (denk
       WhatsApp): het paneel is precies zo hoog als het zichtbare deel van
       het scherm, het invoerveld blijft dus boven het toetsenbord, en
       alleen de berichtenlijst scrolt. Zonder dit rekent position:fixed met
       de layout-viewport: op iOS verdwijnt het invoerveld achter het
       toetsenbord en scrolt de pagina achter het paneel zichtbaar mee. */
    schermVast() {
      if (this._schermVast) return;
      if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) return; /* desktop: hoekpaneel, pagina blijft bruikbaar */
      this._schermVast = true;
      this._scrollY = window.scrollY || 0;
      document.documentElement.classList.add('oc-vergrendeld');
      document.body.classList.add('oc-vergrendeld');
      document.body.style.top = (-this._scrollY) + 'px';
      /* Moderne browsers: de layout-viewport eindigt boven het toetsenbord
         zolang de chat open is. position:fixed klopt dan uit zichzelf; de
         visualViewport-volger hieronder blijft de vangrail voor engines die
         interactive-widget nog niet kennen. Bij het sluiten zetten we de
         oorspronkelijke meta terug, dus de rest van de site merkt er niets
         van. */
      const meta = document.querySelector('meta[name="viewport"]');
      if (meta && this._metaOrigineel == null) {
        this._metaOrigineel = meta.getAttribute('content') || '';
        if (!/interactive-widget/.test(this._metaOrigineel)) {
          meta.setAttribute('content', this._metaOrigineel + ', interactive-widget=resizes-content');
        }
      }
      /* Toetsenbordanimatie: iOS meldt de nieuwe viewport soms pas laat of
         helemaal niet; na focus of blur meten we een paar keer na. */
      this._focusVolger = () => { [80, 250, 600].forEach((ms) => setTimeout(() => this.volgViewport(), ms)); };
      this.input.addEventListener('focus', this._focusVolger);
      this.input.addEventListener('blur', this._focusVolger);
      /* Harde stop voor iOS-randgevallen (rubber-banding via header of
         invoerbalk): elk veeggebaar buiten de berichtenlijst wordt geblokt. */
      this._touchGuard = (e) => {
        const inLijst = e.target && e.target.closest && e.target.closest('.oc-messages');
        if (!inLijst) e.preventDefault();
      };
      document.addEventListener('touchmove', this._touchGuard, { passive: false });
      if (window.visualViewport) {
        this._vvHandler = () => this.volgViewport();
        window.visualViewport.addEventListener('resize', this._vvHandler);
        window.visualViewport.addEventListener('scroll', this._vvHandler);
        this.volgViewport();
      }
    }

    schermLos() {
      if (!this._schermVast) return;
      this._schermVast = false;
      document.documentElement.classList.remove('oc-vergrendeld');
      document.body.classList.remove('oc-vergrendeld');
      document.body.style.top = '';
      if (this._touchGuard) {
        document.removeEventListener('touchmove', this._touchGuard);
        this._touchGuard = null;
      }
      if (this._metaOrigineel != null) {
        const meta = document.querySelector('meta[name="viewport"]');
        if (meta) meta.setAttribute('content', this._metaOrigineel);
        this._metaOrigineel = null;
      }
      if (this._focusVolger) {
        this.input.removeEventListener('focus', this._focusVolger);
        this.input.removeEventListener('blur', this._focusVolger);
        this._focusVolger = null;
      }
      window.scrollTo(0, this._scrollY || 0);
      if (window.visualViewport && this._vvHandler) {
        window.visualViewport.removeEventListener('resize', this._vvHandler);
        window.visualViewport.removeEventListener('scroll', this._vvHandler);
        this._vvHandler = null;
      }
      this.panel.style.height = '';
      this.panel.style.top = '';
    }

    volgViewport() {
      const vv = window.visualViewport;
      if (!vv || !this._schermVast) return;
      /* Twee werelden. Verkleint de browser de layout-viewport zelf tot boven
         het toetsenbord (interactive-widget=resizes-content), dan houdt CSS
         inset:0 het paneel continu passend en zit een inline maat alleen
         maar in de weg: dan wissen we hem. Hangt het toetsenbord als overlay
         over de layout (iOS Safari), dan zetten we de zichtbare maat er hard
         op. LET OP: de layouthoogte meet je met documentElement.clientHeight;
         window.innerHeight beweegt op iOS met de VISUELE viewport mee en
         maskeert de overlay dan juist. */
      const layoutHoogte = document.documentElement.clientHeight || window.innerHeight;
      const overlay = Math.abs(layoutHoogte - vv.height) > 60;
      if (overlay) {
        this.panel.style.height = Math.round(vv.height) + 'px';
        this.panel.style.top = Math.round(vv.offsetTop) + 'px';
      } else {
        this.panel.style.height = '';
        this.panel.style.top = '';
      }
      this.list.scrollTop = this.list.scrollHeight;
    }

    /* Begroeting + starter-chips (de drie grootste klantvragen als eerste zetje) */
    greetingText() {
      const starters = Array.isArray(this.strings.starters) ? this.strings.starters : [];
      return this.strings.greeting + starters.map((s) => '\n[[VRAAG|' + s + ']]').join('');
    }

    /* Is deze paginalading een refresh (F5), of kwam de bezoeker via een link?
       Doorklikken naar een andere pagina moet het gesprek laten doorlopen, want
       anders raakt iemand die tijdens het chatten rondkijkt zijn gesprek kwijt.
       Een bewuste refresh mag wél opnieuw beginnen. */
    /* Een vast kenmerk per browser, náást het sessie-id.
       Het sessie-id hoort bij één gesprek en verspringt bewust bij een refresh
       of na een half uur stilte. Daardoor viel niet meer te zien dat drie
       gesprekken van dezelfde bezoeker waren, en dat is juist wat je wilt
       weten: iemand die drie keer terugkomt met dezelfde vraag heeft een
       probleem dat wij niet oplossen.

       Bewust in localStorage en niet in een cookie: het verlaat het apparaat
       nooit als cookie, wordt niet aan derden doorgegeven en zegt op zichzelf
       niets over wie iemand is. Het is een pseudoniem. Het vervalt na een half
       jaar, zodat er niets eeuwig blijft staan. */
    /* Wie er chat, zoals Shopify Inbox dat weet. Twee bronnen, in deze
       volgorde: de winkel zelf (klant is ingelogd, Liquid zet naam en adres op
       het element) en anders het adres dat de bezoeker eerder in de chat
       achterliet. Dat laatste staat in localStorage met dezelfde houdbaarheid
       als het bezoekerspseudoniem, zodat de twee samen verlopen. */
    klantIdentiteit() {
      var email = (this.dataset.klantEmail || '').trim();
      if (email) return { email: email, naam: (this.dataset.klantNaam || '').trim() };
      try {
        var b = JSON.parse(localStorage.getItem('oc-klant') || 'null');
        if (b && b.email && b.t && (Date.now() - b.t) < 182 * 24 * 60 * 60 * 1000) {
          return { email: b.email, naam: b.naam || '' };
        }
      } catch (e) { /* privémodus: dan even niet */ }
      return null;
    }

    bewaarKlant(email, naam) {
      try {
        localStorage.setItem('oc-klant', JSON.stringify({ email: email, naam: naam || '', t: Date.now() }));
      } catch (e) { /* opslag vol of privémodus: jammer, geen ramp */ }
    }

    /* Meldt een achtergelaten adres direct bij de server, los van de
       berichtenstroom: ook als de bezoeker meteen daarna wegklikt, weet het
       team alsnog wie het was. */
    meldKlant(email, naam) {
      try {
        fetch(this.endpoint + '/klant', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ session_id: this.sessionId, visitor_id: this.bezoekerId(), email: email, naam: naam || '' }),
        }).catch(function () {});
      } catch (e) { /* stil: het adres rijdt sowieso met het volgende bericht mee */ }
    }

    bezoekerId() {
      var SLEUTEL = 'oc-bezoeker';
      var HOUDBAAR_MS = 182 * 24 * 60 * 60 * 1000;
      try {
        var rauw = localStorage.getItem(SLEUTEL);
        if (rauw) {
          var b = JSON.parse(rauw);
          if (b && b.id && b.t && (Date.now() - b.t) < HOUDBAAR_MS) {
            /* Bij elk bezoek de teller opnieuw zetten, zodat een terugkerende
               klant niet halverwege een gesprek een ander pseudoniem krijgt. */
            localStorage.setItem(SLEUTEL, JSON.stringify({ id: b.id, t: Date.now() }));
            return b.id;
          }
        }
        var nieuw = 'ob-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        localStorage.setItem(SLEUTEL, JSON.stringify({ id: nieuw, t: Date.now() }));
        return nieuw;
      } catch (e) {
        /* Privémodus of opslag vol: dan gewoon zonder. De chat werkt door. */
        return '';
      }
    }

    isHerladen() {
      try {
        const nav = performance.getEntriesByType('navigation')[0];
        if (nav && nav.type) return nav.type === 'reload';
        // Oudere browsers: 1 betekent TYPE_RELOAD
        return performance.navigation && performance.navigation.type === 1;
      } catch (e) {
        return false;
      }
    }

    zonderFotoNotitie(t) {
      return String(t || '').replace(/\n\n\[\d+ foto\('s\) meegestuurd[^\]]*\]$/, '');
    }

    restore() {
      let saved = {};
      try { saved = JSON.parse(sessionStorage.getItem(this.storeKey) || '{}'); } catch (e) { /* leeg */ }

      /* Een nieuw gesprek beginnen bij een refresh of na lange stilte. Zonder dit
         plakt alles wat iemand op een dag vraagt aan één sessie vast, en staat in
         het dashboard een vraag over de hanger onder een cadeaugesprek van uren
         eerder. Dat maakt de gespreksdata onbruikbaar om iets uit te leren. */
      const verlopen = saved.t && (Date.now() - saved.t) > NIEUW_GESPREK_NA_MS;
      if (!saved.id || verlopen || this.isHerladen()) {
        this.sessionId = 'oc-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        this.history = [];
        this.laatstGechat = 0;
        try { sessionStorage.removeItem(this.storeKey); } catch (e) { /* prima */ }
        return;
      }

      this.sessionId = saved.id;
      this.history = Array.isArray(saved.history) ? saved.history : [];
      this.laatstGechat = saved.t || 0;
      this.history.forEach((m) => {
        /* De blokhaak-notitie over meegestuurde foto's is voor het model, niet
           voor de klant: bij het terugtekenen gaat hij eruit en komen de
           miniaturen ervoor in de plaats. */
        const el = this.paint(m.role, this.zonderFotoNotitie(m.content));
        if (Array.isArray(m.fotos) && m.fotos.length) this.toonBijlagenInBubbel(el, m.fotos);
      });
      const oudeChips = [...this.list.querySelectorAll('.oc-suggest')];
      oudeChips.slice(0, -1).forEach((el) => el.remove());
    }

    persist() {
      try {
        sessionStorage.setItem(this.storeKey, JSON.stringify({ id: this.sessionId, t: Date.now(), history: this.history.slice(-40) }));
      } catch (e) { /* quota: dan maar niet */ }
    }


    /* ── Foto's meesturen ──────────────────────────────────────────────────
       Een klant die schade meldt heeft het bewijs op zijn telefoon staan. Kon
       hij dat hier niet kwijt, dan moest hij alsnog gaan mailen en was het
       doorzetten maar de helft waard.

       De foto gaat eerst door een verkleining in de browser. Een moderne
       telefoon maakt bestanden van acht megabyte of meer; die over een mobiele
       verbinding duwen duurt zo lang dat mensen afhaken. Teruggebracht naar
       maximaal 1600 pixels op de langste zijde blijft een deuk of een barst
       prima te beoordelen, terwijl het bestand vaak twintig keer kleiner is.
       Lukt het verkleinen niet, bijvoorbeeld bij een HEIC die de browser niet
       kan tekenen, dan gaat het origineel gewoon mee. */
    async verkleinFoto(bestand) {
      const MAX_ZIJDE = 1600;
      const ONGEMOEID = 400 * 1024; // klein genoeg, niet aan zitten
      if (bestand.size <= ONGEMOEID) return bestand;
      try {
        const bitmap = await createImageBitmap(bestand);
        const schaal = Math.min(1, MAX_ZIJDE / Math.max(bitmap.width, bitmap.height));
        if (schaal === 1 && bestand.size < 2 * 1024 * 1024) { bitmap.close(); return bestand; }
        const b = Math.round(bitmap.width * schaal);
        const h = Math.round(bitmap.height * schaal);
        const doek = document.createElement('canvas');
        doek.width = b; doek.height = h;
        doek.getContext('2d').drawImage(bitmap, 0, 0, b, h);
        bitmap.close();
        const blob = await new Promise((res) => doek.toBlob(res, 'image/jpeg', 0.85));
        if (!blob || blob.size >= bestand.size) return bestand;
        return new File([blob], (bestand.name || 'foto').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
      } catch (err) {
        return bestand;
      }
    }

    async voegBijlageToe(bestand) {
      const MAX = 10 * 1024 * 1024;
      const MAX_AANTAL = 8;
      if (!bestand || !/^image\//.test(bestand.type || '')) {
        this.meldBijlageFout(this.strings.photoOnlyImages || 'Only photos can be attached.');
        return;
      }
      if (this.bijlagen.length >= MAX_AANTAL) {
        this.meldBijlageFout(this.strings.photoMax || 'You can attach up to 8 photos.');
        return;
      }

      /* De kaart komt meteen in beeld, met een voorbeeld uit het bestand zelf.
         Wachten tot de upload klaar is zou een seconde of meer niets laten
         gebeuren, en dat leest als een knop die het niet doet. */
      const kaart = { bestand: bestand, url: null, bezig: true, fout: false, voorbeeld: URL.createObjectURL(bestand) };
      this.bijlagen.push(kaart);
      this.tekenBijlagen();

      try {
        const klein = await this.verkleinFoto(bestand);
        if (klein.size > MAX) throw new Error('te groot');
        const form = new FormData();
        form.append('foto', klein, klein.name || 'foto.jpg');
        form.append('sessie', this.sessionId);
        const resp = await fetch(this.endpoint + '/bijlage', { method: 'POST', body: form });
        const data = await resp.json().catch(() => ({}));
        if (!resp.ok || !data.url) throw new Error(data.error || 'upload mislukt');
        kaart.url = data.url;
        kaart.bezig = false;
      } catch (err) {
        kaart.bezig = false;
        kaart.fout = true;
        this.meldBijlageFout(this.strings.photoFailed || 'This photo could not be attached. Please try again.');
      }
      this.tekenBijlagen();
    }

    verwijderBijlage(i) {
      const weg = this.bijlagen.splice(i, 1)[0];
      if (weg && weg.voorbeeld) URL.revokeObjectURL(weg.voorbeeld);
      this.tekenBijlagen();
    }

    meldBijlageFout(tekst) {
      if (!this.strook) return;
      let melding = this.strook.querySelector('.oc-bijlage-fout');
      if (!melding) {
        melding = document.createElement('p');
        melding.className = 'oc-bijlage-fout';
        melding.setAttribute('role', 'status');
        this.strook.appendChild(melding);
      }
      melding.textContent = tekst;
      this.strook.hidden = false;
      clearTimeout(this._bijlageFoutTimer);
      this._bijlageFoutTimer = setTimeout(() => {
        if (melding.parentNode) melding.remove();
        if (!this.bijlagen.length) this.strook.hidden = true;
      }, 6000);
    }

    tekenBijlagen() {
      if (!this.strook) return;
      const fout = this.strook.querySelector('.oc-bijlage-fout');
      this.strook.replaceChildren();
      for (let i = 0; i < this.bijlagen.length; i++) {
        const b = this.bijlagen[i];
        const kaart = document.createElement('div');
        kaart.className = 'oc-bijlage' + (b.bezig ? ' is-bezig' : '') + (b.fout ? ' is-fout' : '');
        const beeld = document.createElement('img');
        beeld.src = b.voorbeeld;
        beeld.alt = '';
        kaart.appendChild(beeld);
        const weg = document.createElement('button');
        weg.type = 'button';
        weg.className = 'oc-bijlage-weg';
        weg.setAttribute('aria-label', this.strings.photoRemove || 'Remove photo');
        weg.innerHTML = '&times;';
        weg.addEventListener('click', () => this.verwijderBijlage(i));
        kaart.appendChild(weg);
        this.strook.appendChild(kaart);
      }
      if (fout) this.strook.appendChild(fout);
      this.strook.hidden = !this.bijlagen.length && !fout;
    }

    /* Kleine miniaturen in de eigen bubbel, zodat de klant terugziet wat hij
       heeft meegestuurd. */
    toonBijlagenInBubbel(el, urls) {
      if (!urls.length) return;
      const rij = document.createElement('div');
      rij.className = 'oc-msg-fotos';
      urls.forEach((u) => {
        const a = document.createElement('a');
        a.href = u; a.target = '_blank'; a.rel = 'noopener';
        const img = document.createElement('img');
        img.src = u; img.alt = this.strings.photoSent || 'Attached photo';
        a.appendChild(img);
        rij.appendChild(a);
      });
      el.appendChild(rij);
    }

    addMessage(role, text, save) {
      this.paint(role, text);
      if (save !== false) { this.history.push({ role: role, content: text }); this.persist(); }
    }

    paint(role, text) {
      const el = document.createElement('div');
      el.className = 'oc-msg oc-msg--' + role;
      this.renderContent(el, text);
      this.list.appendChild(el);
      this.list.scrollTop = this.list.scrollHeight;
      return el;
    }

    /* Plaatst lopende tekst in de bubbel. Opeenvolgende regels die met
       "1. " / "2. " beginnen worden een gestileerd stappenlijstje met
       nummerbolletjes; de rest blijft gewone tekst (pre-wrap). */
    voegTekst(bubble, tekst) {
      const RE_STAP = /^\s*(\d{1,2})[.)]\s+(.*)$/;
      const segs = [];
      for (const regel of String(tekst).split('\n')) {
        const m = regel.match(RE_STAP);
        const vorige = segs[segs.length - 1];
        if (m) {
          if (vorige && vorige.stappen) vorige.stappen.push(m);
          else segs.push({ stappen: [m] });
        } else if (vorige && !vorige.stappen) {
          vorige.tekst += '\n' + regel;
        } else {
          segs.push({ tekst: regel });
        }
      }
      /* Een lege regel tussen twee stappen mag het lijstje niet splitsen. */
      for (let i = segs.length - 2; i > 0; i--) {
        if (!segs[i].stappen && !segs[i].tekst.trim() && segs[i - 1].stappen && segs[i + 1].stappen) {
          segs[i - 1].stappen.push(...segs[i + 1].stappen);
          segs.splice(i, 2);
        }
      }
      segs.forEach((seg, i) => {
        if (!seg.stappen) {
          /* Witruimte rond een stappenblok komt uit de blokmarge, niet uit
             losse regeleindes, anders stapelt de ruimte dubbel op. */
          let t = seg.tekst;
          if (i > 0) t = t.replace(/^\n+/, '');
          if (i < segs.length - 1) t = t.replace(/\n+$/, '');
          if (t) bubble.appendChild(document.createTextNode(t));
          return;
        }
        const lijst = document.createElement('div');
        lijst.className = 'oc-stappen';
        for (const [, nr, inhoud] of seg.stappen) {
          const rij = document.createElement('div');
          rij.className = 'oc-stap';
          const bol = document.createElement('span');
          bol.className = 'oc-stap-nr';
          bol.textContent = nr;
          const tx = document.createElement('span');
          tx.className = 'oc-stap-tekst';
          /* "Titel: uitleg" wordt een vette titelregel met de uitleg
             eronder; een korte stap zonder titeldeel blijft één regel. */
          const dp = inhoud.indexOf(': ');
          if (dp > 0 && dp <= 48) {
            const titel = document.createElement('strong');
            titel.className = 'oc-stap-titel';
            titel.textContent = inhoud.slice(0, dp);
            const uitleg = inhoud.slice(dp + 2);
            tx.appendChild(titel);
            tx.appendChild(document.createTextNode(
              uitleg.charAt(0).toUpperCase() + uitleg.slice(1)
            ));
          } else {
            tx.textContent = inhoud;
          }
          rij.append(bol, tx);
          lijst.appendChild(rij);
        }
        bubble.appendChild(lijst);
      });
    }

    /* Rendert tekst + [[PRODUCT|Naam|url|prijs|img]]-kaarten en
       [[VRAAG|...]]-vervolgvraagchips. Veilig: alles via textContent en
       DOM-API's; productlinks alleen naar oduree.nl, afbeeldingen alleen
       van de eigen Shopify-CDN. */
    renderContent(el, text) {
      /* De parfumeur zit als avatar naast elk antwoord. Het element wordt
         hergebruikt over render-ticks heen, anders herstart zijn animatie
         elke 24 ms en beweegt er niets. */
      let avatar = el.querySelector('.oc-avatar');
      el.replaceChildren();
      if (el.classList.contains('oc-msg--assistant')) {
        if (!avatar) {
          avatar = document.createElement('span');
          avatar.className = 'oc-avatar';
          avatar.setAttribute('aria-hidden', 'true');
          avatar.innerHTML = MASCOTTE_MINI;
        }
        el.appendChild(avatar);
      }
      /* De bubbel draagt de tekst van de spreker; de vervolgvragen staan er
         BUITEN, rechts uitgelijnd aan de klantkant: het zijn concept-berichten
         van de klant (stippellijn = nog niet verstuurd), geen botinhoud. */
      const bubble = document.createElement('div');
      bubble.className = 'oc-bubble';
      el.appendChild(bubble);
      /* [[MAILVRAAG]] is geen inhoud maar een verzoek van de server: toon een
         invulveld voor het e-mailadres, zodat de klant het niet los in de chat
         hoeft te typen. Het token zelf verdwijnt uit beeld. */
      let mailVraag = false;
      text = String(text || '').replace(/\[\[MAILVRAAG\]\]/g, () => { mailVraag = true; return ''; });
      /* Verhaspeld token rechtzetten. Het model tikt er soms naast
         ([[VRAev|...]] in plaats van [[VRAAG|...]]); zonder deze reparatie
         valt de chip niet onder de regex hieronder en ziet de klant rauwe
         syntax in het antwoord staan. */
      text = text.replace(/\[\[\s*([A-Za-z]{2,12})\s*\|/g, (heel, woord) => {
        const w = woord.toUpperCase();
        const juist = w.startsWith('VRA') ? 'VRAAG'
          : (w.startsWith('PRO') || w.startsWith('PDT')) ? 'PRODUCT'
            : w.startsWith('LIN') ? 'LINK'
              : w.startsWith('TAB') ? 'TABEL'
                : w.startsWith('PAK') ? 'PAKKET' : null;
        return juist ? '[[' + juist + '|' : heel;
      });
      const re = /\[\[(PRODUCT|VRAAG|LINK|TABEL|PAKKET)(?:\|([^\]]{0,2000}?))?\]\]/g;
      const chips = [];
      let last = 0;
      let row = null;
      let naTabel = false;
      let m;
      while ((m = re.exec(text))) {
        let before = text.slice(last, m.index).replace(/\n{2,}$/, '\n');
        /* Na een tabel komt de witruimte uit de blokmarge; regeleindes
           erbovenop zouden de ruimte onder de tabel verdubbelen. */
        if (naTabel) before = before.replace(/^\n+/, '');
        if (before.trim()) {
          this.voegTekst(bubble, before);
          row = null;
          naTabel = false;
        }
        const parts = (m[2] || '').split('|');
        if (m[1] === 'PRODUCT' && /^https:\/\/oduree\.nl\//.test(parts[1] || '')) {
          /* In een productgesprek laten we de kaart weg van het artikel waar
             de klant al op staat: die toont hem wat hij al voor zich heeft.
             Een andere vorm van dezelfde geur (de spray naast de hanger) komt
             er wel onder, want dat product ziet hij niet. */
          if (this.zelfdeProduct(parts[0] || '')) { last = re.lastIndex; continue; }
          /* Zelfde kaart twee keer in een blok is altijd een kopieerfout van
             het model; die tweede voegt niets toe en oogt kapot. */
          if (row && [...row.querySelectorAll('.oc-product-name')].some((n) => n.textContent === parts[0])) {
            last = re.lastIndex;
            continue;
          }
          if (!row) {
            row = document.createElement('div');
            row.className = 'oc-products';
            bubble.appendChild(row);
          }
          row.appendChild(this.productCard(parts[0], parts[1], parts[2] || '', parts[3] || ''));
        } else if (m[1] === 'PAKKET') {
          const knop = this.pakketKnop(row);
          if (knop) { bubble.appendChild(knop); row = null; }
        } else if (m[1] === 'VRAAG') {
          const q = parts.join('|').trim();
          if (q) chips.push(q);
        } else if (m[1] === 'TABEL') {
          bubble.appendChild(this.maakTabel(parts));
          row = null;
          naTabel = true;
        } else if (m[1] === 'LINK') {
          const url = parts[1] || '';
          if (this.linkToegestaan(url)) {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener';
            link.textContent = parts[0];
            bubble.appendChild(link);
          } else {
            /* Nooit stilzwijgend laten verdwijnen: toon de tekst met de URL
               erachter, zodat de klant er alsnog iets aan heeft. */
            bubble.appendChild(document.createTextNode(parts[0] + (url ? ' (' + url + ')' : '')));
          }
        }
        last = re.lastIndex;
      }
      let rest = text.slice(last);
      if (naTabel) rest = rest.replace(/^\n+/, '');
      if (rest.trim() || last === 0) this.voegTekst(bubble, rest);
      /* Eén product krijgt het grote podium; vanaf twee worden het compacte
         rijen, anders stapelt het tot een muur van knoppen. */
      for (const r of bubble.querySelectorAll('.oc-products')) {
        r.classList.toggle('oc-products--multi', r.childElementCount > 1);
      }
      if (chips.length) {
        const wrap = document.createElement('div');
        wrap.className = 'oc-suggest';
        for (const q of chips.slice(0, 3)) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'oc-chip';
          b.innerHTML = '<svg viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">' +
            '<path d="M6 0l1.4 4.6L12 6 7.4 7.4 6 12 4.6 7.4 0 6l4.6-1.4Z"/></svg>' +
            '<span>' + this.esc(q) + '</span>';
          b.addEventListener('click', () => {
            if (this.busy) return;
            this.input.value = q;
            this.submit();
          });
          wrap.appendChild(b);
        }
        el.appendChild(wrap);
      }
      if (mailVraag) {
        const vorm = document.createElement('form');
        vorm.className = 'oc-mailvraag';
        vorm.innerHTML =
          '<input type="email" required class="oc-mailvraag-veld" placeholder="' +
          this.esc(this.strings.mailPlaceholder || 'your@email.com') +
          '" autocomplete="email">' +
          '<button type="submit" class="oc-mailvraag-knop">' +
          this.esc(this.strings.mailAskSubmit || 'Send') + '</button>';
        vorm.addEventListener('submit', (e) => {
          e.preventDefault();
          if (this.busy) return;
          const adres = vorm.querySelector('.oc-mailvraag-veld').value.trim();
          if (!adres) return;
          /* Het adres gaat als gewoon bericht de keten in: de server herkent
             het, hangt het aan de escalatie en bedankt. */
          this.bewaarKlant(adres);
          this.input.value = adres;
          vorm.remove();
          this.submit();
        });
        el.appendChild(vorm);
      }
    }

    /* Typmachine: toont de binnenkomende tekst in een menselijk tempo en houdt
       onaffe [[...]]-tokens achter, zodat de klant nooit rauwe syntax ziet en
       chips en productkaarten pas verschijnen als ze compleet zijn. */
    /* De wachtrij: alles wat de klant ziet zolang Oody nog bezig is. Naast
       de ademende stippen loopt er een gouden spoor onder de regel door, en
       de regel zelf verandert als het langer duurt. Zo is op het scherm te
       zien dat er tijd verstrijkt en dat er nog gewerkt wordt, in plaats van
       een stilstaand beeld waarvan je denkt dat het vastloopt. */
    maakWachtrij() {
      const regels = [
        this.strings.typing || 'One moment...',
        this.strings.typing2 || 'Just looking that up...',
        this.strings.typing3 || 'Almost there, I want to get this right.',
      ];
      const rij = document.createElement('div');
      rij.className = 'oc-typing';
      rij.innerHTML = '<span class="oc-mascotte oc-mascotte--werkt" aria-hidden="true">' + this.mascotte() + '</span>' +
        '<span class="oc-typing-regel">' +
        '<span class="oc-typing-dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
        '<span class="oc-typing-tekst"></span></span>' +
        '<span class="oc-typing-spoor" aria-hidden="true"><i></i></span>';
      const veld = rij.querySelector('.oc-typing-tekst');
      veld.textContent = regels[0];
      let stap = 0;
      this.stopWachtrijTekst();
      this._wachtrijTimer = setInterval(() => {
        stap += 1;
        if (stap >= regels.length) { this.stopWachtrijTekst(); return; }
        veld.classList.add('is-wissel');
        setTimeout(() => {
          veld.textContent = regels[stap];
          veld.classList.remove('is-wissel');
        }, 220);
      }, 3800);
      return rij;
    }

    stopWachtrijTekst() {
      if (this._wachtrijTimer) { clearInterval(this._wachtrijTimer); this._wachtrijTimer = null; }
    }

    /* Waar houdt de zichtbare tekst op? Alles wat achteraan nog volgt en
       alleen uit [[VRAAG|...]]-markering en witruimte bestaat, hoeft niet
       uitgetypt te worden: op het scherm verandert er dan namelijk niets
       meer. Zonder deze grens tikte de widget nog ruim een seconde door
       een onzichtbare staart, precies het moment waarop het lijkt alsof
       hij vastloopt. */
    zichtbaarEinde(s) {
      let i = s.length;
      for (;;) {
        const voor = i;
        while (i > 0 && /\s/.test(s[i - 1])) i--;
        if (i > 1 && s[i - 1] === ']' && s[i - 2] === ']') {
          const start = s.lastIndexOf('[[', i - 2);
          if (start !== -1) { i = start; continue; }
        }
        if (i === voor) return i;
      }
    }

    typEffect(bubble, wachtrij) {
      if (this.typStop) this.typStop();
      bubble.classList.add('oc-msg--praat');
      let doel = '';
      let getoond = 0;
      let af = false;
      let timer = null;
      /* De indicator blijft staan tot er echt een letter te zien is. Hem
         al bij de responsheaders weghalen gaf een lege bubbel: geen tekst,
         geen indicator, dus een scherm dat stilstaat. */
      const wegMetWachtrij = () => {
        if (!wachtrij) return;
        this.stopWachtrijTekst();
        wachtrij.remove();
        wachtrij = null;
      };
      const tik = () => {
        timer = null;
        const tot = this.zichtbaarEinde(doel);
        if (getoond < tot) {
          getoond = Math.min(tot, getoond + 3);
          const stuk = this.zonderHalfToken(doel.slice(0, getoond));
          if (stuk) wegMetWachtrij();
          this.renderContent(bubble, stuk);
          this.list.scrollTop = this.list.scrollHeight;
        }
        if (af && getoond >= tot) {
          wegMetWachtrij();
          this.renderContent(bubble, doel);
          bubble.classList.remove('oc-msg--praat');
          this.zetBasis('idle');
          this.flits('blij', 950);
          this.list.scrollTop = this.list.scrollHeight;
          this.typStop = null;
        } else {
          timer = setTimeout(tik, 24);
        }
      };
      this.typStop = () => {
        if (timer) clearTimeout(timer);
        wegMetWachtrij();
        this.renderContent(bubble, doel);
        bubble.classList.remove('oc-msg--praat');
        this.typStop = null;
      };
      tik();
      return {
        zet: (t) => {
          if (!doel && t) {
            /* eerste tekst: klein enthousiast sprongetje, daarna praten */
            if (this._mixTimer) clearTimeout(this._mixTimer);
            this.zetBasis('antwoordt');
            this.flits('begint', 420);
          }
          doel = t;
        },
        vervang: (t) => {
          wegMetWachtrij();
          doel = t; getoond = t.length; this.renderContent(bubble, t);
        },
        klaar: () => { af = true; },
      };
    }

    /* Knipt een onafgemaakt token aan het eind weg: "Waar hou je van? [[VRA"
       wordt "Waar hou je van? " totdat het token compleet is. */
    /* [[TABEL|;To-Go;Full-Size|Inhoud;30 ml;100 ml|...]] wordt een
       vergelijkingstabel: rijen gescheiden door |, cellen door ;. De eerste
       rij is de koprij, de eerste cel van elke rij het aspect-label.
       Alles via textContent, dus injectie-veilig. */
    maakTabel(rijen) {
      let parsed = rijen.map((r) => r.split(';').map((c) => c.trim()));
      /* Vangnet voor een veelgemaakte modelfout: | in plaats van ; binnen
         de rij, waardoor naam en waarde als losse eencels-rijen binnenkomen.
         Bij een koprij die kolommen belooft en een romp van louter
         eencels-rijen voegen we die paarsgewijs weer samen. */
      const kop = parsed[0] || [];
      const romp = parsed.slice(1);
      if (kop.length >= 2 && romp.length >= 2 && romp.every((r) => r.length === 1)) {
        const paren = [];
        for (let i = 0; i < romp.length; i += 2) {
          paren.push([romp[i][0], (romp[i + 1] || [''])[0]]);
        }
        parsed = [kop, ...paren];
      }
      const wrap = document.createElement('div');
      wrap.className = 'oc-tabel';
      const tabel = document.createElement('table');
      parsed.slice(0, 26).forEach((cellen, ri) => {
        const tr = document.createElement('tr');
        cellen.slice(0, 4).forEach((cel, ci) => {
          const el = document.createElement(ri === 0 || ci === 0 ? 'th' : 'td');
          el.scope = ri === 0 ? 'col' : (ci === 0 ? 'row' : '');
          if (!el.scope) el.removeAttribute('scope');
          el.textContent = cel;
          tr.appendChild(el);
        });
        tabel.appendChild(tr);
      });
      wrap.appendChild(tabel);
      return wrap;
    }

    zonderHalfToken(t) {
      const open = t.lastIndexOf('[[');
      if (open > -1 && t.indexOf(']]', open) === -1) t = t.slice(0, open);
      return t.replace(/\[$/, '');
    }

    /* Toegestane bestemmingen voor inline links: de eigen shop en het
       Firmhouse-klantportaal waar het abonnement wordt beheerd. */
    linkToegestaan(url) {
      return /^https:\/\/oduree\.nl\//.test(url)
        || /^https:\/\/checkout\.firmhouse\.com\/[a-z]{2}\/oduree\//.test(url);
    }

    /* Vitrine: het product als podium, met twee acties naast de kaart.
       "Bekijk" gaat naar de PDP; "Vraag verder" stuurt een vervolgvraag over
       dit product terug de chat in (het AI-native moment uit het ontwerp). */
    /* Productrij: kleine foto, naam en prijs, en rechts twee ronde knopjes.
       Het oog opent de productpagina, het karretje legt de variant direct in
       de winkelwagen via het bestaande quick-add-formulier van de theme, dus
       inclusief cart-drawer en alle bestaande listeners. */
    /* Oody linkt naar oduree.nl; op oduree.com dezelfde pagina in de taal van de bezoeker
       (/de/products/<nl-handle> stuurt Shopify zelf door naar de vertaalde handle). */
    lokaleLink(url) {
      try {
        const u = new URL(url);
        if (u.hostname === 'oduree.nl' && window.location.hostname.replace(/^www\./, '') !== 'oduree.nl') {
          const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
          return window.location.origin + root + u.pathname + u.search + u.hash;
        }
      } catch (err) { /* geen geldige URL: laten staan */ }
      return url;
    }

    productCard(name, url, price, img) {
      url = this.lokaleLink(url);
      const wrap = document.createElement('div');
      wrap.className = 'oc-vitrine';

      const a = document.createElement('a');
      a.className = 'oc-product';
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      if (/^https:\/\/(cdn\.shopify\.com|oduree\.nl\/cdn)\//.test(img)) {
        const im = document.createElement('img');
        im.src = img;
        im.alt = name;
        im.loading = 'lazy';
        /* Laadt de foto niet, dan verdwijnt hij: een gebroken icoon in een
           productkaart is erger dan geen foto. */
        im.addEventListener('error', () => im.remove());
        a.appendChild(im);
      }
      const body = document.createElement('span');
      body.className = 'oc-product-body';
      const nm = document.createElement('span');
      nm.className = 'oc-product-name';
      nm.textContent = name;
      body.appendChild(nm);
      /* Het bedrag op een kaartje komt altijd van de chat zelf (Shopify-prijs of
         testprijs van Intelligems), nooit uit de tekst van de bot: het bedrag in
         het token wordt genegeerd. verversKaart zet de prijs zodra het product
         is opgehaald; is de prijs niet zeker, dan blijft het kaartje zonder bedrag. */
      a.appendChild(body);
      wrap.appendChild(a);

      const acts = document.createElement('div');
      acts.className = 'oc-vitrine-acties';

      const view = document.createElement('a');
      view.className = 'oc-rond oc-rond--bekijk';
      view.href = url;
      view.target = '_blank';
      view.rel = 'noopener';
      view.setAttribute('aria-label', this.strings.view || 'View product');
      view.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M1.8 12S6 5.5 12 5.5 22.2 12 22.2 12 18 18.5 12 18.5 1.8 12 1.8 12z"/>' +
        '<circle cx="12" cy="12" r="3.1"/></svg>';
      acts.appendChild(view);

      /* Alleen met een variant-id kunnen we betrouwbaar toevoegen; zonder id
         blijft het bij het oog naar de productpagina. */
      const variant = this.variantUit(url);
      if (variant) {
        wrap.dataset.variant = variant;
        acts.appendChild(this.karKnop(variant));
      }

      wrap.appendChild(acts);
      /* Live bijwerken gebeurt na het renderen: het gesprek hoeft er niet op
         te wachten, en mislukt de call dan blijft de kaart gewoon staan. */
      this.verversKaart(wrap, url);
      return wrap;
    }

    /* Het ronde winkelwagenknopje. Loopt via het quick-add-formulier van de
       theme, dus inclusief cart-drawer en alle bestaande listeners. */
    karKnop(variantId) {
      const form = document.createElement('form');
      form.className = 'oc-rond-form';
      form.method = 'post';
      form.action = '/cart/add';
      form.setAttribute('data-oduree-quick-add', '');
      const id = document.createElement('input');
      id.type = 'hidden';
      id.name = 'id';
      id.value = variantId;
      const aantal = document.createElement('input');
      aantal.type = 'hidden';
      aantal.name = 'quantity';
      aantal.value = '1';
      const knop = document.createElement('button');
      knop.type = 'submit';
      knop.className = 'oc-rond oc-rond--kar';
      knop.setAttribute('aria-label', this.strings.addToCart || 'Add to cart');
      knop.innerHTML =
        '<span class="oc-rond-kar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M8.2 8.6V6.9a3.8 3.8 0 0 1 7.6 0v1.7"/>' +
        '<path d="M4.6 8.6h14.8l-1.1 11a1.6 1.6 0 0 1-1.6 1.4H7.3a1.6 1.6 0 0 1-1.6-1.4z"/>' +
        '</svg></span>' +
        '<span class="oc-rond-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>';
      form.append(id, aantal, knop);
      return form;
    }

    /* Knop onder een samengesteld pakket: legt alle kaarten uit dat blok in
       een keer in de winkelwagen. Het bedrag op de knop komt uit de live
       prijzen van diezelfde kaarten, dus tekst en knop kunnen niet uit elkaar
       lopen. */
    pakketKnop(blok) {
      if (!blok || blok.querySelectorAll('.oc-vitrine').length < 2) return null;
      const knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'oc-pakket';
      knop.dataset.voor = '';
      const tekst = document.createElement('span');
      tekst.className = 'oc-pakket-tekst';
      tekst.textContent = this.strings.addPackage || 'Add this gift to your cart';
      knop.appendChild(tekst);
      const bedrag = document.createElement('span');
      bedrag.className = 'oc-pakket-bedrag';
      knop.appendChild(bedrag);
      knop.addEventListener('click', () => this.pakketToevoegen(blok, knop));
      this._pakketBlokken = this._pakketBlokken || [];
      this._pakketBlokken.push({ blok, knop });
      /* Pas bijwerken als de knop echt in de bubbel hangt: nu is hij nog los,
         en dan slaat werkPakketBij hem over. */
      setTimeout(() => this.werkPakketBij(), 0);
      return knop;
    }

    werkPakketBij() {
      (this._pakketBlokken || []).forEach(({ blok, knop }) => {
        if (!blok.isConnected || !knop.isConnected) return;
        const rijen = [...blok.querySelectorAll('.oc-vitrine[data-variant]')];
        const centen = rijen.reduce((t, r) => t + (parseInt(r.dataset.centen || '0', 10) || 0), 0);
        const bedrag = knop.querySelector('.oc-pakket-bedrag');
        if (bedrag) bedrag.textContent = centen && rijen.length ? this.geld(centen) : '';
        knop.hidden = rijen.length < 2;
      });
    }

    async pakketToevoegen(blok, knop) {
      const items = [...blok.querySelectorAll('.oc-vitrine[data-variant]')]
        .map((r) => ({ id: Number(r.dataset.variant), quantity: 1 }))
        .filter((i) => i.id);
      if (!items.length || knop.disabled) return;
      knop.disabled = true;
      knop.classList.add('is-loading');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('toevoegen mislukt');
        knop.classList.remove('is-loading');
        knop.classList.add('is-success');
        const tekst = knop.querySelector('.oc-pakket-tekst');
        if (tekst) tekst.textContent = this.strings.packageAdded || 'Added to your cart';
        /* Het bedrag op de knop is de som van de losse prijzen. In de
           winkelwagen kunnen daar nog automatische kortingen overheen gaan
           (hanger plus spray telt als Duo), dus daarna tonen we wat de klant
           echt betaalt, met het voordeel erbij. */
        try {
          const wagen = await (await fetch('/cart.js', { cache: 'no-store' })).json();
          const bedrag = knop.querySelector('.oc-pakket-bedrag');
          if (bedrag && wagen && typeof wagen.total_price === 'number') {
            bedrag.replaceChildren(document.createTextNode(this.geld(wagen.total_price)));
            if (wagen.original_total_price > wagen.total_price) {
              const oud = document.createElement('s');
              oud.className = 'oc-pakket-oud';
              oud.textContent = this.geld(wagen.original_total_price);
              bedrag.insertBefore(oud, bedrag.firstChild);
            }
          }
        } catch (er) { /* dan blijft het oorspronkelijke bedrag staan */ }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      } catch (e) {
        /* Niet stil falen: een knop die niets doet laat de klant raden. */
        knop.classList.remove('is-loading');
        knop.disabled = false;
        const tekst = knop.querySelector('.oc-pakket-tekst');
        if (tekst) {
          const was = tekst.textContent;
          tekst.textContent = this.strings.addFailed || 'Could not add, please try again';
          setTimeout(() => { if (tekst.isConnected) tekst.textContent = was; }, 4000);
        }
      }
    }

    /* Prijs en voorraad komen live uit Shopify, nooit uit de tekst van het
       model: een prijs in een prompt is een momentopname en die loopt binnen
       een week achter op de winkel. De kaart toont dus altijd wat er nu in de
       winkel staat, inclusief actieprijs, testprijs en uitverkocht. */
    async haalProduct(handle) {
      if (!handle) return null;
      this._catalogus = this._catalogus || new Map();
      if (this._catalogus.has(handle)) return this._catalogus.get(handle);
      const belofte = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
      this._catalogus.set(handle, belofte);
      return belofte;
    }

    /* Zelfde notatie als de rest van de winkel: \u20ac17,95 (komma, geen spatie), in
       elke taal. Andere valuta (markt buiten de eurozone) in de gewone notatie
       van die munt; de bedragen uit /products/<handle>.js zijn al in die munt. */
    geld(centen) {
      const munt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        if (munt === 'EUR') {
          return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
            .format(centen / 100).replace(/\s/g, '');
        }
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: munt }).format(centen / 100);
      } catch (e) {
        return '\u20ac' + (centen / 100).toFixed(2).replace('.', ',');
      }
    }

    /* ---------- Prijstest (Intelligems) ----------
       Loopt er voor deze bezoeker een prijstest, dan geldt in de chat overal
       de testprijs: op de kaartjes, op de pakketknop en in de prijzen voor de
       worker. Bron is window.igData.price ("29.95", null zonder test), net als
       in het koopblok en oduree-ig-notatie.js. Zonder test, zolang Intelligems
       nog laadt of in een andere valuta (Shopify.currency.rate niet 1) geeft
       dit 0 en blijft de prijs van Shopify staan. */
    testCenten(variantId, fn) {
      const cur = window.Shopify && window.Shopify.currency;
      if (cur && Number(cur.rate) !== 1) return 0;
      const pr = window.igData && window.igData.price;
      const f = fn || 'getPriceByVariantId';
      if (!pr || !variantId || typeof pr[f] !== 'function') return 0;
      let s;
      try { s = pr[f](String(variantId)); } catch (e) { return 0; }
      const c = (s == null || s === '') ? NaN : Math.round(parseFloat(s) * 100);
      return (isFinite(c) && c > 0) ? c : 0;
    }

    /* Intelligems is pas even na de pagina klaar (ig:ready). Kaartjes die dan
       al met de prijs van Shopify staan, zoals een teruggezet gesprek, rekenen
       opnieuw, en de pakketknop telt mee. */
    volgPrijstest() {
      if (this._igVolgt) return;
      this._igVolgt = true;
      const herprijs = () => {
        this.querySelectorAll('.oc-vitrine[data-shop-c]').forEach((rij) => this.zetKaartPrijs(rij));
        this.werkPakketBij();
      };
      window.addEventListener('ig:ready', herprijs);
      window.addEventListener('ig:variationAssignments', herprijs);
    }

    /* Prijs op een kaartje: de testprijs van deze bezoeker, anders die van
       Shopify. Wijkt de testprijs af, dan komt een doorgestreepte prijs alleen
       uit de test zelf, net als op de rest van de site. */
    zetKaartPrijs(rij) {
      if (rij.dataset.shopC == null) return;
      const shop = Number(rij.dataset.shopC) || 0;
      let test;
      if (rij.dataset.prijsVarianten) {
        /* Kaart zonder variant: de testprijs telt alleen als hij voor alle
           varianten gelijk is (of er voor geen enkele een test loopt). */
        const testen = [...new Set(rij.dataset.prijsVarianten.split(',').map((id) => this.testCenten(id)))];
        if (testen.length !== 1) { this.wisKaartPrijs(rij); return; }
        test = testen[0];
      } else {
        test = this.testCenten(rij.dataset.variant);
      }
      const prijs = test || shop;
      const was = (test && test !== shop && !rij.dataset.prijsVarianten)
        ? this.testCenten(rij.dataset.variant, 'getComparePriceByVariantId')
        : (Number(rij.dataset.shopWas) || 0);
      rij.dataset.centen = String(prijs);
      let prijsEl = rij.querySelector('.oc-product-price');
      if (!prijsEl) {
        const body = rij.querySelector('.oc-product-body');
        if (!body) return;
        prijsEl = document.createElement('span');
        prijsEl.className = 'oc-product-price';
        body.appendChild(prijsEl);
      }
      prijsEl.replaceChildren(document.createTextNode(this.geld(prijs)));
      if (was && was > prijs) {
        const oud = document.createElement('s');
        oud.className = 'oc-product-oud';
        oud.textContent = this.geld(was);
        prijsEl.appendChild(oud);
      }
    }

    /* De prijzen van deze bezoeker per productsoort, in centen, voor de worker:
       de testprijs als die er is, anders de prijs uit Shopify. In een andere
       valuta dan de winkelvaluta gaat er niets mee (null). */
    prijzenVoorWorker() {
      const cur = window.Shopify && window.Shopify.currency;
      if (cur && Number(cur.rate) !== 1) return null;
      if (this._shopPrijzen === undefined) {
        try { this._shopPrijzen = JSON.parse(this.dataset.prijzen || '{}') || {}; } catch (e) { this._shopPrijzen = {}; }
      }
      const uit = {};
      Object.keys(PRIJS_VARIANTEN).forEach((soort) => {
        const c = this.testCenten(PRIJS_VARIANTEN[soort]) || Number(this._shopPrijzen[soort]) || 0;
        if (c > 0) uit[soort] = Math.round(c);
      });
      return Object.keys(uit).length ? uit : null;
    }

    /* Kaart naar een product zonder ?variant= en met meer varianten, bijv.
       "Starter · 1 hanger naar keuze". Alleen een bedrag als het zeker is: de
       kaart noemt één stuk en alle varianten (zonder Sample) hebben dezelfde
       Shopify-prijs; de testprijs controleert zetKaartPrijs per variant.
       Anders geen bedrag: liever niets dan een fout bedrag. Geen data-variant en
       geen winkelwagenknop, zodat het pakket er geen willekeurige geur van maakt. */
    zetPrijsZonderVariant(rij, variants) {
      const naam = (rij.querySelector('.oc-product-name') || {}).textContent || '';
      const meerStuks = /\b(duo|trio|quattro)\b|\b([2-9]|1\d)\s*(x|×|stuks?|hangers?|sprays?|flessen|pieces?|items?)\b|\d\s*\+\s*\d/i.test(naam);
      const kandidaten = (variants || []).filter((v) => !/sample/i.test([v.title, v.option1, v.option2].join(' ')));
      const prijzen = [...new Set(kandidaten.map((v) => Number(v.price)))];
      if (meerStuks || !kandidaten.length || prijzen.length !== 1 || !(prijzen[0] > 0)) {
        this.wisKaartPrijs(rij);
        return;
      }
      rij.dataset.prijsVarianten = kandidaten.map((v) => v.id).join(',');
      rij.dataset.shopC = String(prijzen[0]);
      rij.dataset.shopWas = '';
      this.zetKaartPrijs(rij);
    }

    /* Geen zeker bedrag: prijsveld weg en niet meetellen in een pakket. */
    wisKaartPrijs(rij) {
      delete rij.dataset.shopC;
      delete rij.dataset.centen;
      delete rij.dataset.prijsVarianten;
      const el = rij.querySelector('.oc-product-price');
      if (el) el.remove();
    }

    async verversKaart(rij, url) {
      const handle = (/\/products\/([a-z0-9\-_]+)/i.exec(String(url || '')) || [])[1];
      const variantId = this.variantUit(url);
      const data = await this.haalProduct(handle);
      if (!data || !Array.isArray(data.variants) || !rij.isConnected) return;
      /* Zonder variant-id in de kaart weten we niet welke variant bedoeld is.
         Bundelkaarten wijzen naar de productpagina zonder variant; daar is de
         prijs van de eerste losse variant juist het verkeerde bedrag. Heeft het
         product maar EEN variant (zoals de Gift Box), dan is er niets te
         kiezen en mag hij wel. */
      const variant = data.variants.find((v) => String(v.id) === String(variantId)) ||
        (!variantId && data.variants.length === 1 ? data.variants[0] : null);
      if (!variant) {
        if (!variantId) this.zetPrijsZonderVariant(rij, data.variants);
        return;
      }
      rij.dataset.variant = variant.id;
      /* De prijs uit Shopify blijft op de kaart staan: komt de prijstest pas
         later binnen (ig:ready), dan rekent volgPrijstest vanaf hier opnieuw. */
      rij.dataset.shopC = variant.price;
      rij.dataset.shopWas = variant.compare_at_price || '';
      if (!variantId && !rij.querySelector('.oc-rond-form') && variant.available !== false) {
        const acts = rij.querySelector('.oc-vitrine-acties');
        if (acts) acts.appendChild(this.karKnop(variant.id));
      }

      this.zetKaartPrijs(rij);
      this.werkPakketBij();
      if (variant.available === false) {
        rij.setAttribute('data-uitverkocht', '');
        const form = rij.querySelector('.oc-rond-form');
        if (form) {
          const label = document.createElement('span');
          label.className = 'oc-uitverkocht';
          label.textContent = this.strings.soldOut || 'Sold out';
          form.replaceWith(label);
        }
      }
    }

    /* Variant-id uit de kaart-URL; alleen cijfers, anders niets. */
    variantUit(url) {
      const m = /[?&]variant=(\d{6,})/.exec(String(url || ''));
      return m ? m[1] : '';
    }

    async submit() {
      const text = this.input.value.trim();
      /* Alleen foto's versturen mag ook: bij schade is het beeld de boodschap. */
      const klaar = (this.bijlagen || []).filter((b) => b.url && !b.fout);
      const wacht = (this.bijlagen || []).some((b) => b.bezig);
      if ((!text && !klaar.length) || this.busy) return;
      if (wacht) {
        this.meldBijlageFout(this.strings.photoWait || 'One moment, the photo is still uploading.');
        return;
      }
      this.input.value = '';
      /* Voorstellen horen alleen bij de actuele beurt: zodra de klant iets
         verstuurt, zijn de oude opties niet meer relevant. */
      this.list.querySelectorAll('.oc-suggest').forEach((el) => el.remove());

      const fotoUrls = klaar.map((b) => b.url);
      /* In de bubbel ziet de klant zijn eigen tekst met de miniaturen eronder.
         In de geschiedenis die naar het model gaat staat er een regel bij dat
         er foto's zijn: het model kan de beelden zelf niet zien, maar moet wel
         weten dat ze binnen zijn, anders blijft het erom vragen. */
      const zichtbaar = text || (this.strings.photoOnly || 'I am sending you a few photos.');
      const el = this.paint('user', zichtbaar);
      this.toonBijlagenInBubbel(el, fotoUrls);
      const voorModel = fotoUrls.length
        // i18n-ok: regel voor het model, geen klanttekst
        ? zichtbaar + "\n\n[" + fotoUrls.length + " foto('s) meegestuurd en opgeslagen bij dit gesprek. Ze gaan automatisch mee zodra je de melding doorzet; vraag er niet nogmaals om.]"
        : zichtbaar;
      /* De urls gaan als eigen veld mee de geschiedenis in: de backend kijkt
         alleen naar role en content, maar restore() kan er de miniaturen mee
         terugtekenen na een herlaad. */
      this.history.push(fotoUrls.length ? { role: 'user', content: voorModel, fotos: fotoUrls } : { role: 'user', content: voorModel });
      this.persist();
      this.bijlagen.forEach((b) => { if (b.voorbeeld) URL.revokeObjectURL(b.voorbeeld); });
      this.bijlagen = [];
      this.tekenBijlagen();
      this.busy = true;
      this.send.disabled = true;

      this.zetBasis('denkt');
      if (this._mixTimer) clearTimeout(this._mixTimer);
      this._mixTimer = setTimeout(() => {
        if (this._basis === 'denkt') this.zetBasis('mixt');
      }, 5000);
      const typing = this.maakWachtrij();
      this.list.appendChild(typing);
      this.list.scrollTop = this.list.scrollHeight;

      try {
        const resp = await fetch(this.endpoint + '/chat', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify((() => {
            const b = { session_id: this.sessionId, visitor_id: this.bezoekerId(), messages: this.history, page: this.dataset.page || '', locale: this.dataset.taal || this.dataset.locale || 'nl' };
            /* Prijzen zoals deze bezoeker ze ziet (testprijs of Shopify), zodat
               Oody dezelfde bedragen noemt als de kaartjes en de kassa. */
            const prijzen = this.prijzenVoorWorker();
            if (prijzen) b.prijzen = prijzen;
            const wie = this.klantIdentiteit();
            if (wie) { b.customer_email = wie.email; if (wie.naam) b.customer_name = wie.naam; }
            return b;
          })()),
        });
        if (!resp.ok) { typing.remove(); throw new Error('http ' + resp.status); }

        /* De bubbel komt boven de indicator te staan, zodat de wachtrij
           onderaan blijft tot de eerste letter er echt is. */
        const bubble = this.paint('assistant', '');
        this.list.appendChild(typing);
        const typ = this.typEffect(bubble, typing);
        let full = '';
        const reader = resp.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        for (;;) {
          const { done, value } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n\n');
          buffer = lines.pop();
          for (const line of lines) {
            if (!line.startsWith('data: ')) continue;
            const payload = line.slice(6);
            if (payload === '[DONE]') continue;
            try {
              const ev = JSON.parse(payload);
              /* De guardrail draait pas als de tekst er al staat: bij een
                 afkeuring vervangt hij het hele bericht in plaats van aan te vullen. */
              if (typeof ev.vervang === 'string') { full = ev.vervang; typ.vervang(full); }
              else { full += ev.delta || ''; typ.zet(full); }
            } catch (e) { /* halve chunk */ }
          }
        }
        typ.klaar();
        if (!full.trim()) throw new Error('leeg antwoord');
        this.history.push({ role: 'assistant', content: full });
        this.persist();
        this.toonMailStrook();
      } catch (err) {
        typing.remove();
        this.stopWachtrijTekst();
        if (this.typStop) this.typStop();
        this.paint('assistant', this.strings.error);
        if (this._mixTimer) clearTimeout(this._mixTimer);
        this.zetBasis('idle');
        this.flits('oeps', 1600);
      } finally {
        this.busy = false;
        this.send.disabled = false;
        this.input.focus();
      }
    }

    /* De rustige vraag van Shopify Inbox: na het eerste echte antwoord één
       strookje boven het typvak — laat je mailadres achter, dan kunnen we je
       altijd bereiken. Alleen voor bezoekers van wie we nog niets weten, weg
       te klikken, en per sessie hooguit één keer. Vult iemand hem in, dan gaat
       het adres direct naar de server en rijdt het daarna met elk bericht mee. */
    toonMailStrook() {
      if (this.klantIdentiteit()) return;
      if (this.querySelector('.oc-mailstrook') || this.querySelector('.oc-mailvraag')) return;
      try { if (sessionStorage.getItem('oc-mailstrook-weg')) return; } catch (e) { /* dan maar tonen */ }
      const s = this.strings;
      const strook = document.createElement('form');
      strook.className = 'oc-mailstrook';
      strook.innerHTML =
        '<span class="oc-mailstrook-tekst">' +
        this.esc(s.mailStripText || 'Leave your email so we can always reach you.') + '</span>' +
        '<span class="oc-mailstrook-rij">' +
        '<input type="email" required class="oc-mailstrook-veld" placeholder="' +
        this.esc(s.mailPlaceholder || 'your@email.com') + '" autocomplete="email">' +
        '<button type="submit" class="oc-mailstrook-knop">' + this.esc(s.mailStripSave || 'Save') + '</button>' +
        '<button type="button" class="oc-mailstrook-weg" aria-label="' + this.esc(s.mailStripDismiss || 'Dismiss') + '">&times;</button></span>';
      strook.addEventListener('submit', (e) => {
        e.preventDefault();
        const adres = strook.querySelector('.oc-mailstrook-veld').value.trim();
        if (!adres) return;
        this.bewaarKlant(adres);
        this.meldKlant(adres);
        strook.innerHTML = '<span class="oc-mailstrook-tekst">' +
          this.esc(s.mailStripThanks || 'Thanks, we can reach you at %s').split('%s').join(this.esc(adres)) + '</span>';
        setTimeout(() => strook.remove(), 4000);
      });
      strook.querySelector('.oc-mailstrook-weg').addEventListener('click', () => {
        try { sessionStorage.setItem('oc-mailstrook-weg', '1'); } catch (e) { /* prima */ }
        strook.remove();
      });
      const vorm = this.querySelector('.oc-form');
      vorm.parentNode.insertBefore(strook, vorm);
    }

    esc(s) {
      return String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    /* De teksten komen uit Shopify-vertaalsleutels en die zijn HTML-geëscapet
       (foto's staat er als foto&#39;s). Bij het inlezen zetten we ze terug naar
       gewone tekst; waar de widget HTML bouwt, escapet esc() ze weer. */
    ontcijfer(w) {
      if (typeof w === 'string') {
        if (w.indexOf('&') === -1) return w;
        const t = document.createElement('textarea');
        t.innerHTML = w;
        return t.value;
      }
      if (Array.isArray(w)) return w.map((x) => this.ontcijfer(x));
      if (w && typeof w === 'object') {
        const uit = {};
        Object.keys(w).forEach((k) => { uit[k] = this.ontcijfer(w[k]); });
        return uit;
      }
      return w;
    }

    /* De grote mascotte met het schermlezerlabel en de geurchip in de taal
       van de winkel. */
    mascotte() {
      return MASCOTTE
        .replace('%MASCOTTE_LABEL%', () => this.esc(this.strings.mascotLabel || 'Oody, the Oduree AI perfumer'))
        .replace('%MASCOTTE_VANILLE%', () => this.esc(this.strings.mascotVanilla || 'Vanilla'));
    }
  }

  if (!customElements.get('oduree-chat')) customElements.define('oduree-chat', OdureeChat);
})();
